import React, { Component } from 'react'
import { SmartDispatchLayout } from '../../../../src/styled/common-styled'
import { connect } from 'react-redux'
import {
  Row,
  Col,
  Divider,
  Input,
  Tooltip,
  Spin,
  Button,
  Icon,
  Dropdown,
  Menu,
  message,
  Popover,
  Popconfirm,
} from 'antd'
import axios from 'axios'
import longdoAxios from 'lib/longdo'
import { renderToString } from 'react-dom/server'
import LangContext, { i18n } from 'modules/shared/context/langContext'
import { appendScript, removeScript } from 'lib/useScript'
import LocationInfoMarkerLongdoMap from '../../shared/components/map-assets/Marker/LocationInfoMarkerLongdoMap'
import IconMyLocation from '../../shared/components/map-assets/Marker/IconMyLocation'
import {
  updateSmartDispatching,
  createSmartDispatching,
  getNearByLocationSmartDispatching,
} from '../actions'
import AuthorizeComponent from '../../auth/components/AuthorizeComponent'
import ModalConfirmPolygon from './ModalConfirmPolygon'
import NeighborhoodInformation from './NeighborhoodInformation'
import ModalEditDeleteRoute from './ModalEditAndDeleteRoute'
import SearchStartEndLocation from './SearchStartEndLocation'
import PopupMarkerSmartDispatching from './PopupMarkerSmartDispatching'
import ListNearestModal from './ListNearestModal'
import Notification from './Notification'
import IconMarkerSmartDispatching from './IconMarkerSmartDispatching'
import PlaceMarkerLongdoMap from '../../shared/components/map-assets/Marker/PlaceMarkerLongdoMap'
import { getErrorMsg } from 'lib/fetch'
import {
  MIXER_TRUCK_PROHIBITED_ROUTE_TYPE,
  buildProhibitedRoutePolicyArea,
} from '../mixerProhibitedRoutePolicy'
import * as turf from '@turf/turf'
import { checkPermissions } from '../../../lib/helper'

const ButtonGroup = Button.Group

var map = null
var longdo = null

const LongdoEndpoint = process.env.REACT_APP_LONGDO_MAP_ENDPOINT

const BACK_TO_POLICY_DELAY_MS = 2000
class Index extends Component {
  static contextType = LangContext

  constructor(props) {
    super(props)
    this.state = {
      isMenuMapTypeClick: '',
      loadScriptSuccess: false,
      isFireReq: false,
      data: {
        id: '',
        lat: '',
        lng: '',
        name: 'รถโม่เล็ก',
        geoFene: [],
      },
      map: null,
      longdo: null,
      Marker: [],
      Polygon: [],
      Circle: [],
      apiData: null,
      unload_point_show_Area: false,
      unload_point_circle: null,
      unload_point_show_POI: false,
      unload_point_area_Polyline: null,
      isMenuMapToolsCLick: '',
      geoFene: [],
      getIdPolygon: '',
      visible: false,
      cpac_condition: '',
      data_for_edit: [],
      keepMarker: [],
      editable: false,
      tempMarker: [],
      loading: false,
      keepPolygon: [],
      keepSlope: [],
      keepPolygonDoNoExist: [],
      keepCirclePolygon: [],
      keepPolygonLocation: [],
      getNextPropsRoute: null,
      updatebtn: false,
      keepEditPolygon: [],
      visibleSearchTooltip: false,
      isFireReq: false,
      suggest_place: '',
      suggestPlace: [],
      placeMarker: [],
      initialBoundBox: [
        {
          lat: 13.756261348904085,
          lng: 100.5286654829979,
        },
        {
          lat: 13.756261348904085,
          lng: 100.46806901693344,
        },
        {
          lat: 13.73445941145562,
          lng: 100.46806901693344,
        },
        {
          lat: 13.73445941145562,
          lng: 100.5286654829979,
        },
      ],
      showClear: false,
      newGeoFene: [],
      // มาจากปุ่มในหน้าสร้างนโยบายความปลอดภัย (?draw=2)
      // สร้างเส้นทางเสร็จแล้วให้เด้งกลับไปหน้านโยบาย
      backToPolicyAfterCreate: false,
      hideDraw: false,
      ListsRoute: [],
      showSearch: true,
      searchLatitudeLongitudeLongitude: '',
      getNote: '',
      objRoute: null,
      showPlantCpac: false,
      showRoute: false,
      showRouteDoNotEnter: false,
      showSiteSmallTruck: false,
      showSiteLargeTruck: false,
      showSlope: false,
      objPlantCpacFilterBounds: [],
      objRouteFilterBounds: [],
      objRouteDoNotEnterFilterBounds: [],
      objSiteSmallTruckFilterBounds: [],
      objSiteLargeTruckFilterBounds: [],
      objPlantCpacNoFilterBounds: [],
      objRouteNoFilterBounds: [],
      objRouteDoNotEnterNoFilterBounds: [],
      objSiteSmallTruckNoFilterBounds: [],
      objSiteLargeTruckNoFilterBounds: [],
      objSlopeFilterBounds: [],
      objSlopeNoFilterBounds: [],
      siteLargeTruckMarker: [],
      siteSmallTruckMarker: [],
      plantCpacMarker: [],
      showComfirmSavePolygon: false,
      selectTools: '',
      previousPolyline: [],
      btnCarThisArea: false,
      showModalEditDeleteRoute: false,
      showSearchStartEndLocation: false,
      showListNearestModal: false,
      showNotification: false,
      nameRoute: '',
      overlayDropLat: '',
      overlayDropLng: '',
      nearByLocationList: [],
      routePolyline: null,
      start_marker: null,
      end_marker: null,
      my_location: null,
      editValue: '',
      allDataFromSearch: [],
      infoSearch: { location_code: '', location_name: '' },
      showNeighborhoodInformation: false,
      startPointLocationName: '',
      endPointLocationName: '',
      hideToggleWhenDraw: false,
      loadDataThisArea: false,
      disableLoadDataThisArea: false,
      longdoMapLocationList: [],
      markerLongdoMapLocation: null,
      markerWhenDrawing: null,

      endPointLocationCode: '',
      switchDestinationMode: false,
      keepPolygonBigTruck: [],
      objBigTruckRouteFilterBounds: [],
      objBigTruckRouteNoFilterBounds: [],
      showGpsRouteMarker: false,
      showRouteBigTruck: false,
      gpsRouteMarker: [],
      objGpsRouteMarker: [],
      ggStreetviewMarker: null,
      polyGonGpsRoute: [],
      polyGonGpsRouteLayer: [],
    }
  }

  onChangeNameRoute = e => {
    this.setState({
      nameRoute: e.target.values,
    })
  }

  onChangeRemark = e => {
    this.setState({
      getNote: e.target.values,
    })
  }

  postLocationSmartDispatching = async (payload, callback) => {
    console.log({ payload })
    this.setState({
      loading: true,
      hideDraw: false,
    })

    try {
      const routesUrl = await axios.post(
        `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/small-truck-route/locations`,
        payload,
        { headers: { Authorization: `Bearer ${this.props.auth.accessToken}` } },
      )

      let mapKey = this.props.auth.profile.longdo_map_key
      let filter = payload.filter_location_name
      const longdoUrl = await longdoAxios.get(
        `https://search.longdo.com/mapsearch/json/search?key=${mapKey}&keyword=${filter}`,
      )

      const [routeData, longdo] = await Promise.all([routesUrl, longdoUrl])

      let locationList = []
      if (typeof longdo.data.data !== 'undefined') {
        locationList = longdo.data.data.map((v, i) => {
          return {
            id: i,
            name: v.name,
            lat: v.lat,
            lng: v.lon,
          }
        })
      }

      let showSearchStartEndLocation = false
      let showNeighborhoodInformation = false
      let objPlantCpacFilterBounds
      let objPlantCpacNoFilterBounds
      let objSlopeFilterBounds = []
      let objSlopeNoFilterBounds = []
      let objRouteFilterBounds = []
      let objRouteDoNotEnterFilterBounds = []
      let objRouteNoFilterBounds = []
      let objRouteDoNotEnterNoFilterBounds = []
      let objBigTruckRouteFilterBounds = []
      let objBigTruckRouteNoFilterBounds = []
      let objSiteSmallTruckFilterBounds = []
      let objSiteSmallTruckNoFilterBounds = []
      let objSiteLargeTruckFilterBounds = []
      let objSiteLargeTruckNoFilterBounds = []
      let objGpsRouteMarker = []

      if (typeof routeData.data !== 'undefined') {
        const {
          plant,
          big_truck_agency,
          big_truck_route,
          small_truck_route,
          small_truck_agency,
          no_small_truck_route,
          gps_route,
          slope_route,
        } = routeData.data

        showSearchStartEndLocation = this.state.suggestPlace != ''
        showNeighborhoodInformation = this.state.suggest_place != ''

        objPlantCpacFilterBounds = plant.filter_bounds
        objPlantCpacNoFilterBounds = plant.no_filter_bounds

        objRouteFilterBounds = small_truck_route.filter_bounds
        objRouteDoNotEnterFilterBounds = small_truck_route.no_filter_bounds

        objRouteNoFilterBounds = no_small_truck_route.filter_bounds
        objRouteDoNotEnterNoFilterBounds = no_small_truck_route.no_filter_bounds

        objBigTruckRouteFilterBounds = big_truck_route.filter_bounds
        objBigTruckRouteNoFilterBounds = big_truck_route.no_filter_bounds

        objSiteSmallTruckFilterBounds = small_truck_agency.filter_bounds
        objSiteSmallTruckNoFilterBounds = small_truck_agency.no_filter_bounds

        objSiteLargeTruckFilterBounds = big_truck_agency.filter_bounds
        objSiteLargeTruckNoFilterBounds = big_truck_agency.no_filter_bounds

        objSlopeFilterBounds = slope_route.filter_bounds
        objSlopeNoFilterBounds = slope_route.no_filter_bounds

        objGpsRouteMarker = gps_route.filter_bounds
      }

      let allRoute = [
        ...objRouteFilterBounds,
        ...objRouteDoNotEnterFilterBounds,
        ...objRouteNoFilterBounds,
        ...objRouteDoNotEnterNoFilterBounds,
        ...objBigTruckRouteFilterBounds,
        ...objBigTruckRouteNoFilterBounds,
        ...objSlopeFilterBounds,
        ...objSlopeNoFilterBounds,
      ]

      this.setState(
        {
          loading: false,
          longdoMapLocationList: locationList,
          allDataFromSearch: routeData.data,
          getNextPropsRoute: allRoute,
          objRoute: allRoute,
          showSearchStartEndLocation,
          showNeighborhoodInformation,
          objPlantCpacFilterBounds,
          objPlantCpacNoFilterBounds,
          objRouteFilterBounds,
          objSlopeFilterBounds,
          objSlopeNoFilterBounds,
          objRouteDoNotEnterFilterBounds,
          objRouteNoFilterBounds,
          objRouteDoNotEnterNoFilterBounds,
          objBigTruckRouteFilterBounds,
          objBigTruckRouteNoFilterBounds,
          objSiteSmallTruckFilterBounds,
          objSiteSmallTruckNoFilterBounds,
          objSiteLargeTruckFilterBounds,
          objSiteLargeTruckNoFilterBounds,
          objGpsRouteMarker,
        },
        this.displayAllRouteAndMarker,
      )

      if (typeof callback !== 'undefined') {
        callback()
      }
    } catch (error) {
      console.log(error)
    }
  }

  displayAllRouteAndMarker = () => {
    let plant = this.displayMarkerPlantCpac()
    let route = this.displayRoutePolygon()
    let gps = this.displayGpsRouteMarker()
    let small = this.displayMarkerSiteSmallTruck()
    let big = this.displayMarkerSiteLargeTruck()

    this.setState({
      plantCpacMarker: plant,
      keepPolygon: route.keepPolygon,
      keepPolygonDoNoExist: route.keepPolygonDoNoExist,
      keepPolygonBigTruck: route.keepPolygonBigTruck,
      keepSlope: route.keepPolygonSlope,
      gpsRouteMarker: gps,
      siteSmallTruckMarker: small,
      siteLargeTruckMarker: big,
    })
  }

  handleGetdistanceList = (value, start, end) => {
    if (this.state.routePolyline != null) {
      map.Overlays.remove(this.state.routePolyline)
      this.setState({
        routePolyline: null,
      })
    }
    if (this.state.my_location != null) {
      map.Overlays.remove(this.state.my_location)
      this.setState({
        my_location: null,
      })
    }
    if (this.state.end_marker != null) {
      map.Overlays.remove(this.state.end_marker)
      this.setState({
        end_marker: null,
      })
    }
    if (this.state.start_marker != null) {
      map.Overlays.remove(this.state.start_marker)
      this.setState({
        start_marker: null,
      })
    }

    let self = this
    let features = []
    let distance = value.data.data.distance
    let interval = value.data.data.interval
    value.data.features.map(item => {
      item.geometry.coordinates.map(coordinatesItem => {
        features = [
          ...features,
          { lat: coordinatesItem[1], lng: coordinatesItem[0] },
        ]
      })
    })
    if (
      this.props.auth.profile.map_type === 'google' ||
      this.props.auth.profile.map_type === 'longdo'
    ) {
      let mapFeatures = features.map(f => ({
        lat: f.lat,
        lon: f.lng,
      }))
      let start_marker = new window.longdo.Marker(start, {
        icon: {
          html: renderToString(
            <IconMyLocation
              image="/img/Component 14 – 49.png"
              title={i18n[this.props.language].y.you}
            />,
          ),
          offset: { x: 12, y: 45 },
        },
        draggable: false,
      })

      let end_marker = new window.longdo.Marker(end, {
        icon: {
          html: renderToString(
            <IconMyLocation
              image={
                this.props.auth.profile.company_id === 3009
                  ? '/img/Qmixpng.png'
                  : '/img/Group 18442.png'
              }
              title=""
            />,
          ),
          offset: { x: 12, y: 45 },
        },
        draggable: false,
      })

      let routePolyline = new longdo.Polyline(mapFeatures, {
        strokeOpacity: 0.7,
        strokeWeight: 5,
        lineColor: '#7C64EA',
      })

      self.setState({
        routePolyline: routePolyline,
        start_marker: start_marker,
        end_marker: end_marker,
        showSearchStartEndLocation: true,
        showNeighborhoodInformation: false,
        suggest_place: '',
        selectTools: 'directionRoute',
        hideDraw: true,
      })
      map.Overlays.add(routePolyline)
      map.Overlays.add(start_marker)
      map.Overlays.add(end_marker)

      if (longdo != null) {
        let latArry = []
        let lngArry = []

        for (let j = 0; j < features.length; j++) {
          latArry.push(parseFloat(features[j].lat))
          lngArry.push(parseFloat(features[j].lng))
        }

        let minLat = Math.min.apply(null, latArry)
        let maxLat = Math.max.apply(null, latArry)

        let minLon = Math.min.apply(null, lngArry)
        let maxLon = Math.max.apply(null, lngArry)

        let bound = { minLon, minLat, maxLon, maxLat }

        map.bound(bound)
      }
    }

    let hours = Math.floor(interval / 3600) // get hours
    let minutes = Math.floor((interval - hours * 3600) / 60) // get minutes

    if (hours < 10) hours = '0' + hours
    if (minutes < 10) minutes = '0' + minutes

    self.setState({
      distance: distance / 1000,
      intervalHours: hours,
      intervalMins: minutes,
    })
  }

  drawRouteNearBylocation = location => {
    this.clearMarkerLongdomapLocation()
    this.clearOverlayOnMapWhenSearchStartEnd()
    let getItem = this.state.nearByLocationList.find(item => {
      return item.location_code == location.locationCode
    })
    this.setState({
      endPointLocationName: location.locationName,
      endPointLocationCode: location.locationCode,
    })

    let url = `${LongdoEndpoint}/map/mmroute/geojson/route?flon=${this.state.overlayDropLng}&flat=${this.state.overlayDropLat}&tlon=${getItem.lng}1&tlat=${getItem.lat}&mode=d&type=17&locale=th&key=${this.props.auth.profile.longdo_map_key}`
    let startPoint = {
      lon: this.state.overlayDropLng,
      lat: this.state.overlayDropLat,
    }
    let endPoint = { lon: getItem.lng, lat: getItem.lat }

    if (this.state.switchDestinationMode) {
      url = `${LongdoEndpoint}/map/mmroute/geojson/route?flon=${getItem.lng}&flat=${getItem.lat}&tlon=${this.state.overlayDropLng}1&tlat=${this.state.overlayDropLat}&mode=d&type=17&locale=th&key=${this.props.auth.profile.longdo_map_key}`
    }

    longdoAxios({
      method: 'get',
      url: url,
    })
      .then(res => {
        this.handleGetdistanceList(res, startPoint, endPoint)
      })
      .catch(err => {
        console.log(err)
      })
  }

  onCloseNotification = () => {
    this.setState({
      showNotification: false,
    })
  }

  openNotification = detail => {
    this.setState({
      showNotification: true,
      infoSearch: {
        location_code: detail.code,
        location_name: detail.name,
      },
    })
  }

  handleShowNearestModal = () => {
    this.setState({
      showListNearestModal: true,
    })
  }

  onCloseNearestModal = () => {
    this.setState({
      showListNearestModal: false,
    })
  }

  handleGetIdForEditOrDelete = objRoute => {
    this.setState({
      getNote: objRoute,
      showModalEditDeleteRoute: true,
    })
  }

  showModalEditDelete = () => {
    this.setState({
      showModalEditDeleteRoute: true,
    })
  }

  onCLoseModalEditDeleteRoute = () => {
    this.setState({
      showModalEditDeleteRoute: false,
    })
  }

  getMapBound = () => {
    let bound = map.bound()
    return [
      { lat: bound.maxLat, lng: bound.maxLon },
      { lat: bound.maxLat, lng: bound.minLon },
      { lat: bound.minLat, lng: bound.minLon },
      { lat: bound.minLat, lng: bound.maxLon },
    ]
  }

  getRoute = () => {
    let smallTruckRoute = []
    let bigTruckRoute = []
    let smallTruckNotAllowRoute = []
    let slopeRoute = []

    if (this.state.showRoute) {
      smallTruckRoute = [
        ...this.state.objRouteFilterBounds,
        ...this.state.objRouteNoFilterBounds,
      ]
    }

    if (this.state.showSlope) {
      slopeRoute = [
        ...this.state.objSlopeFilterBounds,
        ...this.state.objSlopeNoFilterBounds,
      ]
    }

    if (this.state.showRouteDoNotEnter) {
      smallTruckNotAllowRoute = [
        ...this.state.objRouteDoNotEnterFilterBounds,
        ...this.state.objRouteDoNotEnterNoFilterBounds,
      ]
    }

    if (this.state.showRouteBigTruck) {
      bigTruckRoute = [
        ...this.state.objBigTruckRouteFilterBounds,
        ...this.state.objBigTruckRouteNoFilterBounds,
      ]
    }

    return [
      ...smallTruckRoute,
      ...bigTruckRoute,
      ...smallTruckNotAllowRoute,
      ...slopeRoute,
    ]
  }

  /// handle marker โรงงาน
  handleShowPlantCpac = () => {
    if (this.state.showPlantCpac == true) {
      this.state.plantCpacMarker.map(item => {
        map.Overlays.remove(item)
      })

      this.setState({
        showPlantCpac: false,
        plantCpacMarker: [],
      })
      return
    }

    this.setState(
      {
        showPlantCpac: true,
        initialBoundBox: this.getMapBound(),
      },
      this.loadData,
    )
  }

  //handle เส้นทางลาดชัน
  handleShowSlopeRoute = () => {
    if (this.state.showSlope == true) {
      this.state.keepSlope.map(item => {
        map.Overlays.remove(item.overlay)
      })

      this.setState({
        keepSlope: [],
        showSlope: false,
      })
      return
    }

    this.setState(
      {
        showSlope: true,
        initialBoundBox: this.getMapBound(),
      },
      this.loadData,
    )
  }

  /// handle เส้นทางรถโม่เล็ก
  handleShowRoute = () => {
    if (this.state.showRoute == true) {
      this.state.keepPolygon.map(item => {
        map.Overlays.remove(item.overlay)
      })

      this.setState({
        keepPolygon: [],
        showRoute: false,
      })
      return
    }

    this.setState(
      {
        showRoute: true,
        initialBoundBox: this.getMapBound(),
      },
      this.loadData,
    )
  }

  /// handle เส้นทางรถโม่เล็กห้ามเข้า
  handleShowRouteDoNotEnter = () => {
    if (this.state.showRouteDoNotEnter == true) {
      this.state.keepPolygonDoNoExist.map(item => {
        map.Overlays.remove(item.overlay)
      })

      this.setState({
        keepPolygonDoNoExist: [],
        showRouteDoNotEnter: false,
      })
      return
    }

    this.setState(
      {
        showRouteDoNotEnter: true,
        initialBoundBox: this.getMapBound(),
      },
      this.loadData,
    )
  }

  /// handle เส้นทางรถโม่ใหญ่
  handleShowRouteBigTruck = () => {
    if (this.state.showRouteBigTruck == true) {
      this.state.keepPolygonBigTruck.map(item => {
        map.Overlays.remove(item.overlay)
      })

      this.setState({
        keepPolygonBigTruck: [],
        showRouteBigTruck: false,
      })
      return
    }

    this.setState(
      {
        showRouteBigTruck: true,
        initialBoundBox: this.getMapBound(),
      },
      this.loadData,
    )
  }

  /// handle marker รถโม่เล็กที่ calc จาก gps
  handleshowGpsRouteMarker = () => {
    if (this.state.showGpsRouteMarker == true) {
      this.state.gpsRouteMarker.map(item => {
        map.Overlays.remove(item)
      })

      map.Overlays.remove(this.state.polyGonGpsRouteLayer)

      this.setState({
        gpsRouteMarker: [],
        polyGonGpsRouteLayer: [],
        polyGonGpsRoute: [],
        showGpsRouteMarker: false,
      })
      return
    }

    this.setState(
      {
        showGpsRouteMarker: true,
        gpsRouteMarker: [],
        polyGonGpsRouteLayer: [],
        polyGonGpsRoute: [],
        initialBoundBox: this.getMapBound(),
      },
      this.loadData,
    )
  }

  /// handle marker หน่วยงานรถโม่เล็ก
  handleShowSiteSmallTruck = () => {
    if (this.state.showSiteSmallTruck == true) {
      this.state.siteSmallTruckMarker.map(item => {
        map.Overlays.remove(item)
      })

      this.setState({
        showSiteSmallTruck: false,
        siteSmallTruckMarker: [],
      })
      return
    }

    this.setState(
      {
        showSiteSmallTruck: true,
        initialBoundBox: this.getMapBound(),
      },
      this.loadData,
    )
  }

  /// handle marker หน่วยงานรถโม่ใหญ่
  handleShowSiteLargeTruck = () => {
    if (this.state.showSiteLargeTruck == true) {
      this.state.siteLargeTruckMarker.map(item => {
        map.Overlays.remove(item)
      })

      this.setState({
        showSiteLargeTruck: false,
        siteLargeTruckMarker: [],
      })

      return
    }

    this.setState(
      {
        showSiteLargeTruck: true,
        initialBoundBox: this.getMapBound(),
      },
      this.loadData,
    )
  }

  displayMarkerPlantCpac = () => {
    let markers = this.state.objPlantCpacFilterBounds.map(item => {
      let marker = new window.longdo.Marker(
        { lon: item.lng, lat: item.lat },
        {
          title: item.location_code + ' ' + item.location_name,
          icon: {
            html: renderToString(
              <IconMarkerSmartDispatching
                image={
                  parseInt(item.comp_id) === 10
                    ? '/img/Qmixpng.png'
                    : '/img/Group 18442.png'
                }
              />,
            ),
          },
          draggable: false,
        },
      )
      map.Overlays.add(marker)
      return marker
    })

    return markers
  }

  displayRoutePolygon = () => {
    this.state.keepSlope.map(item => {
      map.Overlays.remove(item.overlay)
    })
    this.state.keepPolygon.map(item => {
      map.Overlays.remove(item.overlay)
    })

    this.state.keepPolygonDoNoExist.map(item => {
      map.Overlays.remove(item.overlay)
    })

    this.state.keepPolygonBigTruck.map(item => {
      map.Overlays.remove(item.overlay)
    })

    let polygonArr = []
    let polygonBigTruckArr = []
    let polygonArrDoNotExist = []
    let polygonSlopeArr = []

    this.state.objRoute.map(value => {
      let polygon = null
      if (value.geofence != '' && value.geofence != undefined) {
        let arr = value.geofence.split(',')
        let convertedStreet = []
        for (let i = 0; i < arr.length; i = i + 2) {
          convertedStreet.push({
            lon: parseFloat(arr[i + 1]),
            lat: parseFloat(arr[i]),
          })
        }
        if (convertedStreet.length > 1) {
          let lineColor = this.getLineColor(value.small_truck_route)
          polygon = new longdo.Polyline(convertedStreet, {
            title: '(' + value.id.toString() + ')' + ' ' + value.route_name,
            lineWidth: 4,
            lineColor: lineColor,
            fillColor: lineColor,
            editable: false,
          })

          if (value.small_truck_route == '1') {
            polygonArr.push({
              id: value.id,
              overlay: polygon,
            })
          } else if (value.small_truck_route == '2') {
            polygonArrDoNotExist.push({
              id: value.id,
              overlay: polygon,
            })
          } else if (value.small_truck_route == '3') {
            polygonBigTruckArr.push({
              id: value.id,
              overlay: polygon,
            })
          } else if (value.small_truck_route == '7') {
            polygonSlopeArr.push({
              id: value.id,
              overlay: polygon,
            })
          }

          if (
            this.state.showRoute ||
            this.state.showRouteDoNotEnter ||
            this.state.showRouteBigTruck ||
            this.state.showSlope
          ) {
            map.Overlays.add(polygon)
          }
        }
      }
    })

    return {
      keepPolygon: polygonArr,
      keepPolygonDoNoExist: polygonArrDoNotExist,
      keepPolygonBigTruck: polygonBigTruckArr,
      keepPolygonSlope: polygonSlopeArr,
    }
  }

  displayGpsRouteMarker = () => {
    let imageUrl = '/img/pngmarker/small-truck-gps-bright-small.png' //this.state.isMenuMapToolsCLick === 'findArea' ? "/img/pngmarker/small-truck-gps-trans.png" : "/img/pngmarker/small-truck-gps-bright.png"
    let gpsRouteMarker = this.state.objGpsRouteMarker.map(item => {
      let marker = new window.longdo.Marker(
        { lon: item.lng, lat: item.lat },
        {
          icon: {
            url: imageUrl,
            offset: { x: 12, y: 45 },
          },
        },
      )

      map.Overlays.add(marker)
      return marker
    })

    return gpsRouteMarker
  }

  displayMarkerSiteSmallTruck = () => {
    let markers = this.state.objSiteSmallTruckFilterBounds.map(item => {
      let marker = new window.longdo.Marker(
        { lon: item.lng, lat: item.lat },
        {
          title: item.location_code + ' ' + item.location_name,
          icon: {
            url:
              this.props.language == 'th'
                ? `data:image/png;base64,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`
                : `data:image/png;base64,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`,
            offset: { x: 12, y: 45 },
          },
          draggable: false,
        },
      )
      map.Overlays.add(marker)
      return marker
    })

    return markers
  }

  displayMarkerSiteLargeTruck = () => {
    let markers = this.state.objSiteLargeTruckFilterBounds.map(item => {
      let marker = new window.longdo.Marker(
        { lon: item.lng, lat: item.lat },
        {
          title: item.location_code + ' ' + item.location_name,
          icon: {
            url:
              this.props.language == 'th'
                ? `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAwCAYAAABnjuimAAAABHNCSVQICAgIfAhkiAAAB8FJREFUWEfVmQtUTWkUx//n3tsTk2jlNSSZVqYsj8FkjMdgKIwhIo0eHkOMJGOWxzKzGu/Hkm5KLGtIUpK3pBmDkTehGJOQwohFyltU98w+n266t/s45xbLnLVa555zvr337+xv733298WhBkeAEp/xQE/wcOGAljwHBzo78zzug0M+x+Mmna/T83MKFQ7/Nh1FppojvdIOfyV8CcCboHqSsK0kaR6Z9GIHeDliNgUjT4qsKFDvrZBb3oWvDJhDyl2kGNA1lmDL6WU3q+QIEwtsEHTCWpiVlCCAlM6mKWxVU0BteTVwObAofhpyDOk3CBoQiX5QYStB2tQ2pIY+HskvVAhIno6X+uzoBfVTwo8ebqA/+TuFrFBOCZhRWgbPxBko1GVPJ6hfJLxkPLa/D0Atz2ZyNugaOwYl2rargQZGwl2lwiGOg5VYUHsbJ8g4BR48uYFyValYMd3jKAw2hmAkhRuF8NtDA9Q/HM0gQyZB2omx1slpGAJ6x4DjqB7QUfgkH2FbOokRNTiGwmBp3DTM0g8agTSC7C/GkpncCkv8ryAjdwcS00OZSP06TfHoeUGluLmiDqYMSEbsoYkoenZbjNrKMbwKX8SF4qT6RqVHA5XwIF/vl6KtiW0bzPM9j3lJ7rhdmFVN1Nq8PlYHFWP2pja4W3xFimph3k/EhaCbBmhYGGR5trhENz+VpI0Gz/fNwvHsOKRdWFFNVCG3gEeHH3H477V4XvJQqmoKU4yKDcEWQZB5lEpREEVZjGRNJDBn+FHk3juFpGM/oW+7YMgpqX7PXMlUtbBrj8Fd5iI6dQR5SCVdPY/8+zK47J+KVwzUX0JsalurCvp9vzgoZOaISfNhw9xa9MeMIWkYu8oMKr5MOqjgSY7K1VSc4ryjUdeqFA/phrkpmt41qLoCcJREPhS4iaZACjLvATSHSpULR21bBM1/SG2BWiisEZU6nKnr2GoIJnluwYRoa9NitAKKU8FWAN1FoN/WFqi7sw9i9o/CxZtpCOy9BvWs7LBit6ep6pkcgXYQQDMJtJ2pmrSn3sr8I9SxsMUnTbvhzsPLSKCPQfa/h0xVrwYdygVE4JG4No5Do/qt8aykSFRNtCTgktdPagSoFlZxCOVo3aPx8del2dG+M6YM3MY8JZebYzXVxQt5e2oFQowSIfOFqc+nqXcwJODSrBdrPIQpDB64gzolOZQpJoc1erlNQB3LBtiXsUQMJ6ibG8NRsT9FNfRzMRJCI7Jw9CUcy96IPWfmixHROca3RwRsrBtXfhiMKSJHekrKep/uK9DB8RvM3dwOpeV6Vw3G7MK1+dewMK+L87k7jY6tzHq/CMyScVhsXILDmqDHSDg6HZk39sL/q2jEHwmhtu4OHBt1gWfHGfgzKwpXC9KpJNmza8dGnfDi1SOkX16PrPyUShNe7vOpm8rByZx4o2YpgZ5YWsKOC1wFF+r9so1JcBSXG4LLsHLPIBQUZWN5YC5r31o36YqRXy5H3OHJOHON1tX0rRfC43bhRYrBpWjr0B9e7vPwS2LHylZQKGnXCo4j+YRGb6wTgRIpib5MPm+aEhEJpQs0My8F7R0HUYtzDqv3j8T9x7mwNKuH0MEpDDT+yFRmXDm+AClnF+NAViS7lgIqJNKmUMSqu6c1lFATDXlVF6jQ3kUT4OgeSgh1c9nOPkzFJI9EvCp9jvUHx7NroWc9fTUJKRmLJIHStPMyBZrG/oB76n7UjX4IXyi9S2NdoHPiXSkM/oFTY3f8POIkpm9wQNHTW4gYdwc7T4XhyOV1DGzeqAs4d2MXdp/+lV3P9T6BnDvpRqdePe0sodRepDJl0Kv6YvTNEoOj6b1L07uITW/42NtIO7+Cfq8Cz5fTumkbGtRrjnV/BKJdywEY2X05UjOWGQN9peLhvGkabmmA+sXAXvaadt8AS10hYBgUGNNnHYRl89IdvTGi2zL07xCKyJShLNubNXBFkEcC+wSfvb6dXWfm7cWu02F6o42mXUlrpmnqAZrL5QgsoVidaShWTXlmb9Ma1hb1WbX4uKEbZnodZK3gJeqwdB1CSSothVPVXRMNUM9IWNirkEYz2csUIH0ybR084dsjnHn86ctCVm/ViaUtQ3FZRl/rIRunYl/VZ9V2SoSliXUpDhFsZ0OwpJBFuKBA+M3OFcGkvvc2A95oMrgjJwygFSDN6HfqladBUOHhuHA0KJMhnTS76oNlcEYta0pXvJv+uOQRRMV9rc4c0ScVuAGWqsdUaDnaB9I6TIE0ODuAsOj3puQ5rG+cUZ9QYx1K2+DLq9ZY5hlj7tFhUZcI3cuiFx+sLkMmgwqCAeFwpX13YRHYV63IBE4NBpIvphsLXhYjKjkMrw15XFR8V1VAq4E+ZEAAdquaTMaMsDypiGk6v6bYjyozw4KEyQxW1GF06qtp4cHRFlAXag29yPZoUtDUmCWCEyZgH8X7DkU5dpvybxzpoFpU/pFIpXg1uB4uV+Gr+FD8ZeyFDD2vOWgUGnJlyNW3kiVvxlPJ8asJpOQY1WeM+tnx9MZvWiXN4wV5szV58+4HAcoqg5LtDrtrAc2l/fiFNYWsNY8Kivyj4IwyXKaEUbAsB2494OAs7G1+UKDMqxEYRqdoiteH1Fj4xAazXexaOWqcTLVCIULJ/wb0P5RJFTjvSA63AAAAAElFTkSuQmCC`
                : `data:image/png;base64,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`,
            offset: { x: 12, y: 45 },
          },
          draggable: false,
        },
      )

      map.Overlays.add(marker)
      return marker
    })

    return markers
  }

  clearOverlayOnMap = () => {
    map.Overlays.clear()
    this.setState({
      plantCpacMarker: [],
      keepPolygon: [],
      keepPolygonDoNoExist: [],
      keepPolygonBigTruck: [],
      keepSlope: [],
      siteSmallTruckMarker: [],
      siteLargeTruckMarker: [],
      gpsRouteMarker: [],
      polyGonGpsRoute: [],
      polyGonGpsRouteLayer: [],
    })
  }

  clearOverlayOnMapWhenSearchStartEnd = () => {
    this.state.plantCpacMarker.map(item => {
      map.Overlays.remove(item)
    })

    this.state.siteSmallTruckMarker.map(item => {
      map.Overlays.remove(item)
    })

    this.state.siteLargeTruckMarker.map(item => {
      map.Overlays.remove(item)
    })

    this.state.gpsRouteMarker.map(item => {
      map.Overlays.remove(item.overlay)
    })

    this.setState({
      plantCpacMarker: [],
      siteSmallTruckMarker: [],
      siteLargeTruckMarker: [],
      gpsRouteMarker: [],
    })
  }

  // render longdo map
  initialMap = () => {
    longdo = window.longdo
    map = new longdo.Map({
      placeholder: document.getElementById('map'),
      zoom: 6,
    })

    map.location({ lon: 100.49149, lat: 13.75005 }, true)
    map.Ui.Fullscreen.visible(false)
    map.Ui.DPad.visible(false) // เครื่องมือเลื่อนแผนที่ (อยู่บริเวณมุมบนซ้าย)
    map.Ui.Zoombar.visible(false) // แถบซูม (อยู่บริเวณมุมบนซ้าย)
    map.Ui.Geolocation.visible(false) // ปุ่มบอกตำแหน่งปัจจุบัน (อยู่บริเวณมุมบนซ้าย)
    map.Ui.Toolbar.visible(false) // แถบเครื่องมือ (อยู่บริเวณมุมบนซ้าย)
    map.Ui.LayerSelector.visible(false) // ตัวเลือกรูปแบบแผนที (อยู่บริเวณมุมบนขวา)
    map.Ui.Crosshair.visible(false) // สัญลักษณ์แสดงจุดกึ่งกลาง (ตรงกลางแผนที่)
    map.zoom(true, true)
    map.Layers.externalOptions({
      googleQuery: `key=${this.props.auth.profile.google_map_key}`,
      //   googleQuery: `key=AIzaSyCBh7O-7raiK3L0zOguKR1uAryIwBCQFA4`,
    })
    map.Layers.setBase(longdo.Layers.GOOGLE_ROADMAP)

    map.Ui.Mouse.enableInertia(false)
    map.Ui.Keyboard.enable(false)
    map.zoom(16)

    this.bindMapEvent()
    const self = this
    map.Event.bind('ready', function() {
      map.Layers.setBase(longdo.Layers.GOOGLE_ROADMAP)

      // ?draw=2 = มาจากปุ่มในหน้านโยบายความปลอดภัย (นโยบายเส้นทางรถโม่ห้ามเข้า)
      // เปิดโหมดวาดเส้นทางให้ทันที ไม่ต้องไปหาเมนูเครื่องมือเอง
      // เรียกใน event ready เพราะ handleDrawPolyline ใช้ map.bound()
      const drawParam = /[?&]draw=([^&]+)/.exec(window.location.search)
      if (drawParam && drawParam[1] === MIXER_TRUCK_PROHIBITED_ROUTE_TYPE) {
        self.setState({ backToPolicyAfterCreate: true })
        self.handleDrawPolyline(MIXER_TRUCK_PROHIBITED_ROUTE_TYPE)
      }
    })

    if (!map instanceof longdo.Map) {
      window.location.reload(true)
    }
  }

  bindMapEvent = () => {
    const self = this
    map.Event.bind('overlayClick', function(overlay) {
      if (overlay.title != undefined && self.state.selectTools == '') {
        if (overlay.title.charAt(0) == '(') {
          let firstSplit = overlay.title.split('(')
          let secondSplit = firstSplit[1].split(')')
          self.setState(
            {
              getMarkerObj: overlay,
              getIdPolygon: secondSplit[0],
            },
            () => {
              let note = self.state.objRoute.filter(
                item => item.id == self.state.getIdPolygon,
              )
              self.handleGetIdForEditOrDelete(note)
            },
          )
        } else {
          self.handleGetLocationFromSearch({
            lat: overlay.location().lat,
            lng: overlay.location().lon,
            name: overlay.title,
          })
        }
      }
    })

    map.Event.bind('overlayChange', function(overlay) {
      const ele = document.getElementsByClassName(
        'ldmap_overlay ldmap_popupholder',
      )
      Array.prototype.forEach.call(ele, function(el) {
        el.style.display =
          self.state.isMenuMapToolsCLick == 'updateRoute' ? '' : 'none'
      })
    })

    map.Event.bind('zoom', function() {
      var result = map.zoom() // Get the zoom value
      let bound = map.bound()
      self.setState({
        initialBoundBox: [
          { lat: bound.maxLat, lng: bound.maxLon },
          { lat: bound.maxLat, lng: bound.minLon },
          { lat: bound.minLat, lng: bound.minLon },
          { lat: bound.minLat, lng: bound.maxLon },
        ],
      })

      if (
        !self.state.updatebtn &&
        result >= 14 &&
        self.state.showClear === false &&
        self.state.selectTools !== 'pinDoesNotExistInSystem' &&
        self.state.selectTools !== 'directionRoute'
      ) {
        self.setState({
          disableLoadDataThisArea: false,
          loadDataThisArea: true,
        })
      } else {
        self.setState({
          disableLoadDataThisArea: true,
          loadDataThisArea:
            self.state.isMenuMapToolsCLick == 'updateRoute' ||
            self.state.selectTools == 'pinDoesNotExistInSystem'
              ? false
              : true,
        })
      }
    })

    map.Event.bind('drop', function() {
      var result = map.zoom() // Get the zoom value
      let bound = map.bound()
      self.setState(
        {
          initialBoundBox: [
            { lat: bound.maxLat, lng: bound.maxLon },
            { lat: bound.maxLat, lng: bound.minLon },
            { lat: bound.minLat, lng: bound.minLon },
            { lat: bound.minLat, lng: bound.maxLon },
          ],
        },
        () => {
          if (
            !self.state.updatebtn &&
            result >= 14 &&
            self.state.showClear === false &&
            self.state.selectTools !== 'pinDoesNotExistInSystem' &&
            self.state.selectTools !== 'directionRoute'
          ) {
            self.setState({
              disableLoadDataThisArea: false,
              loadDataThisArea: true,
            })
          } else {
            self.setState({
              disableLoadDataThisArea: true,
              loadDataThisArea:
                self.state.isMenuMapToolsCLick == 'updateRoute' ||
                self.state.selectTools == 'pinDoesNotExistInSystem'
                  ? false
                  : true,
            })
          }
        },
      )
    })
  }

  checkDisableButton = () => {
    var result = map.zoom() // Get the zoom value

    if (result >= 14) {
      this.setState({
        disableLoadDataThisArea: false,
        loadDataThisArea: true,
      })
    } else {
      this.setState({
        disableLoadDataThisArea: true,
        loadDataThisArea:
          this.state.isMenuMapToolsCLick == 'updateRoute' ||
          this.state.selectTools == 'pinDoesNotExistInSystem'
            ? false
            : true,
      })
    }
  }

  createRoute = (note, routeName, routeType) => {
    // เก็บพิกัดไว้ก่อน setState ด้านล่างจะเคลียร์ overlay/ฟอร์ม
    const geoFene = this.state.geoFene.slice()
    const isProhibitedRoute =
      String(routeType) === MIXER_TRUCK_PROHIBITED_ROUTE_TYPE

    // เส้นทางรถโม่ห้ามเข้า: ส่งพื้นที่นโยบายไปด้วย
    // backend จะสร้าง cpac_policy (policy_type = 10) พร้อมเส้นทางใน transaction เดียว
    // แล้วผูกกันไว้ที่ cpac_route_policy_map เพื่อให้ลบเส้นทางแล้วนโยบายหายตามกัน
    let policyArea = null
    if (isProhibitedRoute) {
      try {
        policyArea = buildProhibitedRoutePolicyArea(geoFene)
      } catch (e) {
        // สร้างพื้นที่ไม่ได้ = ไม่บันทึกอะไรเลย ดีกว่าได้เส้นทางที่ไม่มีนโยบาย
        message.error(
          `${this.context.c.createMixerTruckProhibitedRoutePolicyFail}: ${e.message}`,
        )
        return
      }
    }

    map.Overlays.clear()
    this.checkDisableButton()
    this.props.createSmartDispatching(
      {
        accessToken: '',
        companies_id: this.props.auth.profile.company_id,
        created_user_id: this.props.profile.id,
        small_truck_route: routeType,
        geofence: geoFene.toString(),
        lat: geoFene[0].toString(),
        lng: geoFene[1].toString(),
        remark: note,
        name: routeName,
        policy_area: policyArea,
      },
      res => {
        if (isProhibitedRoute) this.afterCreateProhibitedRoute(res)
        // เหมือน updateRoute — รอ response ก่อนโหลดใหม่
        this.reloadRouteData()
      },
    )
    this.setState(
      {
        keepEditPolygon: [],
        showClear: false,
        getNote: '',
        showSearch: true,
        selectTools: '',
        hideToggleWhenDraw: false,
        suggest_place: '',
      },
      () => {
        this.handleFormBack()
        this.setState({
          showSearch: true,
          isMenuMapToolsCLick: '',
        })
        this.onCloseModalComfirmpolygon()
      },
    )
  }

  // ผลลัพธ์การสร้างเส้นทางรถโม่ห้ามเข้า + นโยบายที่ผูกกัน (ทำใน transaction เดียว)
  // fail = ไม่มีอะไรถูกบันทึก / policy_id ว่าง = ได้เส้นทางแต่ไม่ได้นโยบาย ต้องแจ้งให้รู้
  afterCreateProhibitedRoute = res => {
    if (!res || res.status !== 'success') {
      message.error(
        `${this.context.c.createMixerTruckProhibitedRoutePolicyFail}${
          res && res.msg ? `: ${res.msg}` : ''
        }`,
      )
      return
    }
    if (!res.policy_id) {
      message.error(this.context.c.createMixerTruckProhibitedRoutePolicyFail)
      return
    }
    if (!res.store_audio_id) {
      // ไม่มีแถว store_audio type POLICY_10 — นโยบายมีแล้วแต่กล่อง GPS จะไม่มีเสียงพูด
      message.warning(this.context.m.mixerTruckProhibitedRoutePolicyNoSound)
      return
    }
    message.success(this.context.c.createMixerTruckProhibitedRoutePolicySuccess)

    // มาจากหน้าสร้างนโยบายเท่านั้น (?draw=2) — พาผู้ใช้กลับไปที่เดิม
    // เข้าหน้านี้เองไม่ต้องเด้งไปไหน
    // หน่วง 2 วิ ให้อ่าน toast ทันก่อนเปลี่ยนหน้า
    if (this.state.backToPolicyAfterCreate) {
      this.setState({ backToPolicyAfterCreate: false })
      this.backToPolicyTimer = setTimeout(() => {
        this.backToPolicyTimer = null
        this.props.history.push('/cpac-policy')
      }, BACK_TO_POLICY_DELAY_MS)
    }
  }

  // ผลลัพธ์การแก้เส้นทางรถโม่ห้ามเข้า + นโยบายที่ผูกกัน (transaction เดียว)
  afterUpdateProhibitedRoute = res => {
    if (!res || res.status !== 'success') {
      message.error(
        `${this.context.u.updateMixerTruckProhibitedRoutePolicyFail}${
          res && res.msg ? `: ${res.msg}` : ''
        }`,
      )
      return
    }
    if (!res.policy_id) {
      // ไม่มีนโยบายผูกอยู่ (เส้นทางเก่าที่สร้างก่อนระบบผูกอัตโนมัติ)
      message.warning(this.context.m.mixerTruckProhibitedRoutePolicyNotLinked)
      return
    }
    message.success(this.context.u.updateMixerTruckProhibitedRoutePolicySuccess)
  }

  updateRoute = (note, routeName, routeType) => {
    if (this.state.newGeoFene != []) {
      const geoFene = this.state.newGeoFene.slice()
      const isProhibitedRoute =
        String(routeType) === MIXER_TRUCK_PROHIBITED_ROUTE_TYPE

      // เส้นทางรถโม่ห้ามเข้า: แนวเส้นเปลี่ยน พื้นที่นโยบายต้องเปลี่ยนตาม
      // คำนวณ corridor ใหม่แล้วส่งไปให้ backend อัปเดต cpac_policy ที่ผูกไว้
      // (เหมือนตอนสร้าง — ดู ../mixerProhibitedRoutePolicy.js)
      let policyArea = null
      if (isProhibitedRoute) {
        try {
          policyArea = buildProhibitedRoutePolicyArea(geoFene)
        } catch (e) {
          // คำนวณไม่ได้ = ไม่บันทึกอะไรเลย ดีกว่าเส้นทางกับนโยบายไม่ตรงกัน
          message.error(
            `${this.context.u.updateMixerTruckProhibitedRoutePolicyFail}: ${e.message}`,
          )
          return
        }
      }

      map.Overlays.clear()
      this.checkDisableButton()
      this.props.updateSmartDispatching(
        {
          accessToken: '',
          companies_id: this.props.auth.profile.company_id,
          user_id: this.props.profile.id,
          geofence: geoFene.toString(),
          lat: this.state.data.lat,
          lng: this.state.data.lng,
          id: this.state.getIdPolygon,
          remark: note,
          small_truck_route: routeType,
          name: routeName,
          policy_area: policyArea,
        },
        res => {
          if (isProhibitedRoute) this.afterUpdateProhibitedRoute(res)
          this.reloadRouteData()
        },
      )
      map.Overlays.remove(this.state.keepEditPolygon[0].overlay)
      this.setState(
        {
          updatebtn: false,
          editable: false,
          keepEditPolygon: [],
          getNote: '',
          showSearch: true,
          newGeoFene: [],
          selectTools: '',
          editValue: '',
          hideToggleWhenDraw: false,
          suggest_place: '',
        },
        () => {
          this.handleFormBack()
          this.onCloseModalComfirmpolygon()
          this.setState({
            showSearch: true,
            isMenuMapToolsCLick: '',
          })
        },
      )
    } else {
      let self = this
      map.Overlays.remove(this.state.keepEditPolygon[0].overlay)
      this.setState(
        {
          updatebtn: false,
          editable: false,
          keepEditPolygon: [],
          getNote: '',
          editValue: '',
        },
        () => {
          let result = map.zoom()
          this.handleFormBack()
          this.onCloseModalComfirmpolygon()
          setTimeout(function() {
            if (result >= 15) {
              self.loadData()
            } else {
              self.initialLoadDataToDefaultLocation()
            }
          }, 500)
        },
      )
    }
  }

  // โหลดข้อมูลบนแผนที่ใหม่หลังบันทึก/แก้ไข/ลบ
  reloadRouteData = () => {
    if (map === null) return
    if (map.zoom() >= 15) {
      this.loadData()
    } else {
      this.initialLoadDataToDefaultLocation()
    }
  }

  loadData = async callback => {
    if (map instanceof longdo.Map) {
      await this.clearOverlayOnMap()
      this.postLocationSmartDispatching(
        {
          get_plant: this.state.showPlantCpac,
          get_small_truck_route: this.state.showRoute,
          get_slope_route: this.state.showSlope,
          get_no_small_truck_route: this.state.showRouteDoNotEnter,
          get_small_truck_agency: this.state.showSiteSmallTruck,
          get_big_truck_agency: this.state.showSiteLargeTruck,
          filter_location_name: this.state.suggest_place,
          location_visibility: this.props.auth.profile.location_visibility,
          companies_id: this.props.auth.profile.company_id,
          bounds: this.state.initialBoundBox,

          get_big_truck_route: this.state.showRouteBigTruck,
          get_gps_route: this.state.showGpsRouteMarker,
          zoom: map === null ? 10 : map.zoom(),
        },
        callback,
      )
    } else {
      alert('แผนที่โหลดไม่เสร็จสมบูรณ์ กรุณาลองใหม่อีกครั้ง')
      window.location.reload(true)
    }
  }

  componentDidMount() {
    appendScript(
      'script',
      `${LongdoEndpoint}/map2/?key=` + this.props.auth.profile.longdo_map_key,
      this,
    )
  }

  componentDidUpdate(prevProp, prevState) {
    if (this.state.loadScriptSuccess != prevState.loadScriptSuccess) {
      this.initialMap()
    }
  }

  componentWillUnmount() {
    // ออกจากหน้าก่อนครบ 2 วิ ต้องยกเลิก ไม่งั้นดึงผู้ใช้ออกจากหน้าที่เพิ่งเปิด
    if (this.backToPolicyTimer) {
      clearTimeout(this.backToPolicyTimer)
      this.backToPolicyTimer = null
    }

    removeScript('longdo')
  }

  handleFormBack = () => {
    this.handleClearAllOverlays()
  }

  displayMarker = data => {
    let keepPolyginMarker = []

    let tempMarker = []
    if (data.length > 0) {
      let latArr = []
      let lngArr = []

      for (let i = 0; i < data.length; i++) {
        latArr.push(parseFloat(data[i].lat))
        lngArr.push(parseFloat(data[i].lng))
      }
      let minLat = Math.min.apply(null, latArr)
      let minLon = Math.min.apply(null, lngArr)
      let maxLat = Math.max.apply(null, latArr)
      let maxLon = Math.max.apply(null, lngArr)
      let boundbox = { minLon, minLat, maxLon, maxLat }

      data.map(value => {
        let polygon = null
        let circle = null
        let dest_marker = new window.longdo.Marker(
          { lon: value.lng, lat: value.lat },
          {
            title: value.id.toString(),
            dataId: value.id,
            icon: {
              url:
                'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAElklEQVRoge2aT6gVZRjGf8/lIiIuRERcRNCcjXfIEImWIfeARIvCVhEFroKWLQxahASJRIRJRkZk5MZLixCzoptzkBZCFnETnbPxDtKihchFREQuh/O0mJl75pz778yfIy16Lx/zLM687/N83zPvzDdzRcORtMMnjWcx+yTtBvq27wB/SeoEUfxPk/XURJKkHQI8b/weZhaYEmANijiFPWBe6P0giq81Ubu2gMXZcJvEZ4YjBaID0gbJGBVxX3AaczToxMt16tcSkLTDHcDPwHO4kG18fBl4OYjih1U5VBaw2A6nsX+ROOiMmIB1caHgCL4odDiI4n4VHtNVBQjeMRzEazK/b/Sj5JtGU8A+zIuIbcDoSryEeBM4U5FH+Uja4W7jRcz2IUsAQmeQ3w2i7r3iOYvtcBdwEvv1NVLelXgqiLoPynKZKntCxvWI0HZJrPxJgI4h3holD9CK4rvAGxKfSOnvC2OX0atVuFQSIDhse8XLtgGuSv4giOJ1z2tFMZijwI3iuZmjDlfhUlpAMjszbbw/971xbsSTQdTd9EIMOt0ecAo7F57neTZpz5SlU/4itrRLsBUYuoIMV0qk+TW13FDsJM37qAyf8hZyKnrUQsJLJbIsjVoo41J6QksLEH5g6KP0zpp2T2G0p0SaPThrXIM8y5ScfaiyAtJ94YfCSNnAgF8YN4Xxofy8Qp47QRT3ytIpLSC9YyoxeetX1kV0NGmHWzc7f7Edbse8nV6/mYQU3yrLBareB+zrIPBKcWz22v48aYfr5kza4RbwN0hP5MLTEMCNKlwqCQB+H7VQijmC+SmZndmbPWLnxElmZ/ZjIsErK78vWMjwWxUilZ6FBFcHD2TCK2YSlg8BNwULSTuMnU7S00bPgLPfAzZSjkH46mMTgLQALGF2DnWSAZ4yHEAcwNnGJtvhFG2zguXE6HYVKpUsFERxT3B5tYXWwWyC0Xxrg0eQxgWk4R+KXWhdvLrbrMLA91VZVBZgdAmrlxMpdqQhzDq2GeD7QKcqj8oCWlG8JNGpbSFzKYji0nfg2gKyOF/XQuDzdQjUE2BfMH6Ys7azVlTEkLVZr4XvAPN1KNQSEHS692RdWGOHNTwKu7ZhzFzQ6dZ6rVLXQhi+Suc0n9URnG1a7GGcHvV13fq1BUi+Ar41sI0ZwmSCNIyNr0ks1K1fW0AQdftCX5a2EPpio/3zYxMAYHzW+FGKx7GQl4C5Jmo3IqAVde8K5sa1kKSzdV4nFqMRAQBGp8a0UA/4tKm6jQkALwCdMSz0XRDFfzdVtTEBragL8NGmFrI/bqomNLoCYDwv6foGFroiqZEPG3k0KqCVvpn7cAMLnWiidRajUQFZfItJVlkI/pBU67lnrWhcQBDFPUknVlvIx5uefZjMCgCcA24XLHQddHEShSYiIIjiZeD4wEIcCzrVPiFtFpNaAYBzkm5J+lMwkdmfeCTt8LWkHY79zrRKVP7IN2bMGSZinf/jvxKN/K8EsCUb09nIm0N+7BeOvWwsZ6NWNCFgK7CD8h2tD9yjwleZYjS1ApCuQP6da6MVyFeh9uwD/Asypo/TAASupgAAAABJRU5ErkJggg==',
              offset: { x: 12, y: 45 },
            },
            draggable: false,
          },
        )
        tempMarker.push(dest_marker)

        if (value.geo_fence != '' && value.geo_fence != undefined) {
          let location_marker = new window.longdo.Marker(
            { lon: value.lng, lat: value.lat },
            {
              title: value.policy_name,
              detail: value.policy_name,
              icon: {
                html: renderToString(
                  <LocationInfoMarkerLongdoMap
                    key={value.id}
                    lat={value.lat}
                    lng={value.lng}
                    title={value.name}
                  />,
                ),
                offset: { x: 12, y: 45 },
              },
              draggable: false,
            },
          )
          // มี geo_fance
          let arr = value.geo_fence.split(',')
          let convertedStreet = []

          for (let i = 0; i < arr.length; i = i + 2) {
            convertedStreet.push({
              lon: parseFloat(arr[i + 1]),
              lat: parseFloat(arr[i]),
            })
          }
          if (convertedStreet.length > 1) {
            polygon = new longdo.Polyline(convertedStreet, {
              lineWidth: 4,
              lineColor: '#A17DC0',
              fillColor: 'rgba(0, 128, 255, 0.6)',
              editable: false,
            })
            keepPolyginMarker.push({
              id: value.id,
              overlay: polygon,
            })
            map.Overlays.add(polygon)
          }
        } else {
          let location_marker = new window.longdo.Marker(
            { lon: value.lng, lat: value.lat },
            {
              title: value.policy_name,
              detail: value.policy_name,
              icon: {
                html: renderToString(
                  <LocationInfoMarkerLongdoMap
                    key={value.id}
                    lat={value.lat}
                    lng={value.lng}
                    title={value.name}
                  />,
                ),
                offset: { x: 12, y: 45 },
              },
              draggable: false,
            },
          )
          circle = new longdo.Circle(
            {
              lon: value.lng,
              lat: value.lat,
            },
            parseInt(value.radius) / 100000,
            {
              lineWidth: 4,
              lineColor: '#A17DC0',
              fillColor: 'rgba(0, 128, 255, 0.6)',
            },
          )
        }
        map.Overlays.add(dest_marker)
      })

      this.setState({
        tempMarker: [...this.state.tempMarker, ...tempMarker],
        keepMarker: [...this.state.keepMarker, ...keepPolyginMarker],
      })
      map.bound(boundbox)
    }
  }

  editlocation = () => {
    map.Overlays.clear()
    if (this.state.keepCirclePolygon.length > 0) {
      this.state.keepCirclePolygon.map(item => {
        map.Overlays.remove(item.overlay)
      })
    }
    if (this.state.keepPolygonLocation.length > 0) {
      this.state.keepPolygonLocation.map(item => {
        map.Overlays.remove(item.overlay)
      })
    }

    this.setState(
      {
        editable: true,
        visible: false,
        updatebtn: true,
        showSearch: false,
        isMenuMapToolsCLick: 'updateRoute',
        hideToggleWhenDraw: true,
      },
      () => {
        let editLocationObj = this.state.getNextPropsRoute.filter(
          item_id => item_id.id == this.state.getIdPolygon,
        )
        let getFilterPolygonId = this.state.keepPolygon.filter(
          item_id => item_id.id == this.state.getIdPolygon,
        )
        this.displayEditPolygon(editLocationObj)
      },
    )
  }

  displayEditPolygon(ListsView) {
    let value = ListsView[0]
    let polygonArr = []
    this.setState({
      data: {
        id: value.id,
        lat: value.lat,
        lng: value.lng,
        name: 'รถโม่เล็ก',
        geoFene: [],
      },
      selectTools: value.small_truck_route,
      editValue: value,
    })
    if (value.radius === '') {
    } else {
      // polygon
      this.setState({ haveMarkerOnMap: true })
      let arr = value.geofence.split(',')
      let convertedStreet = []
      let self = this
      let polygon = null
      for (let i = 0; i < arr.length; i = i + 2) {
        convertedStreet.push({
          lon: parseFloat(arr[i + 1]),
          lat: parseFloat(arr[i]),
        })
      }
      polygon = new longdo.Polyline(convertedStreet, {
        title: '(' + value.id.toString() + ')' + ' ' + value.route_name,
        lineWidth: 4,
        lineColor: this.getLineColor(value.small_truck_route),
        fillColor: this.getLineColor(value.small_truck_route),
        editable: true,
      })

      polygonArr.push({
        id: parseInt(value.id),
        overlay: polygon,
      })
      this.setState(
        {
          keepEditPolygon: polygonArr,
        },
        () => {},
      )
      if (polygon != null) {
        polygon.location().map(val => {
          self.state.newGeoFene.push(val.lat, val.lon)
        })
      }
      map.Overlays.add(polygon)
      this.setState({ polygonLayer: polygon })

      map.Event.bind('overlayDrop', function() {
        if (self.state.isMenuMapToolsCLick == 'updateRoute') {
          if (polygon != null) map.Overlays.remove(self.state.polygonLayer)
          self.setState({ polygonLayer: null })

          self.state.newGeoFene = []

          if (polygon != null) {
            polygon.location().map(val => {
              self.state.newGeoFene.push(val.lat, val.lon)
            })
          }
          map.Overlays.add(polygon)
          self.setState({ polygonLayer: polygon })
        }
      })

      map.zoom(17)
      this.setState({
        hideDraw: false,
        loadDataThisArea: false,
        disableLoadDataThisArea: true,
      })
    }
  }

  displayPreviousPolygon = () => {
    map.Overlays.remove(this.state.markerWhenDrawing)
    map.Overlays.remove(this.state.polyline)

    let arr = this.state.geoFene
    let convertedStreet = []

    for (let i = 0; i < arr.length; i = i + 2) {
      convertedStreet.push({
        lon: parseFloat(arr[i + 1]),
        lat: parseFloat(arr[i]),
      })
    }

    if (convertedStreet.length == 1) {
      this.setState({
        geoFene: [],
        previousPolyline: [],
        markerWhenDrawing: null,
        polyline: null,
      })
      return
    }

    let lineColor = this.getLineColor(this.state.selectTools)
    let polygon = new longdo.Polyline(convertedStreet, {
      lineWidth: 4,
      lineColor: lineColor,
      fillColor: lineColor,
    })

    let getLastTwoIndexArr = arr.slice(-2)
    let currentMakerWhenDrawing = new window.longdo.Marker({
      lon: getLastTwoIndexArr[1],
      lat: getLastTwoIndexArr[0],
    })

    this.setState({
      markerWhenDrawing: currentMakerWhenDrawing,
      polyline: polygon,
    })

    map.Overlays.add(currentMakerWhenDrawing)
    map.Overlays.add(polygon)
  }

  deletelocation = () => {
    this.setState(
      {
        visible: false,
      },
      () => {
        let self = this
        axios
          .delete(
            `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/small-truck-route/delete/${this.state.getIdPolygon}?deleted_by=${this.props.profile.id}`,
            {
              headers: {
                Authorization: `Bearer ${this.props.auth.accessToken}`,
              },
            },
          )
          .then(function(response) {
            map.Overlays.clear()
            let result = map.zoom()
            if (result >= 15) {
              self.loadData()
            } else {
              self.initialLoadDataToDefaultLocation()
            }
            this.setState({
              showSearch: true,
              isMenuMapToolsCLick: '',
            })
          })
          .catch(function(error) {
            console.log(error)
          })

        message.success(`delete success`)
      },
    )
  }

  // Clear Map
  handleClearLocationMarker = () => {
    if (this.state.Marker != null) {
      // Marker
      this.displayMarker([])
      map.Overlays.remove(this.state.Marker)
      this.setState({
        Marker: [],
      })
    }

    if (this.state.circle != null) {
      // วงกลม
      map.Overlays.remove(this.state.circle)
      this.setState({
        circle: null,
      })
    }
  }

  handleClearAllOverlays = () => {
    this.handleClearLocationMarker()
    this.handleClearDrawPolygon()

    this.setState({
      isMenuMapToolsCLick: '',
      data: {
        ...this.state.data,
        lat: '',
        lng: '',
      },
      geoFene: [],
      showSearch: false,
    })
  }

  handleSavePolygon = (note, routeName, routeType) => {
    this.createRoute(note, routeName, routeType)
  }

  handleUpdatePolygon = (note, routeName, routeType) => {
    this.updateRoute(note, routeName, routeType)
  }

  handleCancelEditPolygon = () => {
    let result = map.zoom()
    this.checkDisableButton()
    map.Overlays.remove(this.state.keepEditPolygon[0].overlay)
    this.setState(
      {
        updatebtn: false,
        editable: false,
        keepEditPolygon: [],
        getNote: '',
        selectTools: '',
        showClear: false,
        hideDraw: true,
        geoFene: [],
        previousPolyline: [],
        newGeoFene: [],
        suggest_place: '',
      },
      () => {
        this.handleFormBack()
        if (result >= 15) {
          this.loadData()
        } else {
          this.initialLoadDataToDefaultLocation()
        }
        this.setState({
          showSearch: true,
          isMenuMapToolsCLick: '',
          hideToggleWhenDraw: false,
        })
      },
    )
  }

  handleCancelDrawPolygon = () => {
    map.Overlays.clear()
    this.checkDisableButton()
    this.setState(
      {
        showClear: false,
        isMenuMapToolsCLick: '',
        hideDraw: true,
        getNote: '',
        selectTools: '',
        geoFene: [],
        previousPolyline: [],
        newGeoFene: [],
        suggest_place: '',
      },
      () => {
        this.handleFormBack()
        this.setState({
          showSearch: true,
          hideToggleWhenDraw: false,
        })
        let result = map.zoom()
        if (result >= 15) {
          this.loadData()
        } else {
          this.initialLoadDataToDefaultLocation()
        }
      },
    )
  }

  clearAreaMarkerUnloadPoint = () => {
    if (this.state.unload_point_area_Polyline != null) {
      map.Overlays.remove(this.state.unload_point_area_Polyline)
      this.setState({
        unload_point_area_Polyline: null,
      })
    }
    if (this.state.unload_point_area_Polygon != null) {
      map.Overlays.remove(this.state.unload_point_area_Polygon)
      this.setState({
        unload_point_area_Polygon: null,
      })
    }
    if (this.state.unload_point_pin_marker != null) {
      map.Overlays.remove(this.state.unload_point_pin_marker)
      this.setState({
        unload_point_pin_marker: null,
      })
    }

    this.setState({
      unload_point_show_Area: false,
      unload_point_area_Polyline: [],
    })
  }

  handleClearDrawPolygon = () => {
    if (this.state.marker != null) {
      // Marker
      map.Overlays.remove(this.state.marker)
    }

    if (this.state.polygon != null) {
      // Polygon
      map.Overlays.remove(this.state.polygon)
    }

    if (this.state.polyline != null) {
      map.Overlays.remove(this.state.polyline)
    }

    if (this.state.ggStreetviewMarker !== null) {
      map.Overlays.remove(this.state.ggStreetviewMarker)
    }

    this.setState({
      marker: null,
      polygon: null,
      polyline: null,
      ggStreetviewMarker: null,
    })
  }

  clearMarkerLongdomapLocation = () => {
    if (this.state.markerLongdoMapLocation != null) {
      map.Overlays.remove(this.state.markerLongdoMapLocation)
    }

    if (this.state.ggStreetviewMarker !== null) {
      map.Overlays.remove(this.state.ggStreetviewMarker)
    }

    this.setState({
      markerLongdoMapLocation: null,
      ggStreetviewMarker: null,
    })
  }

  handleGotoLocation = async (value, type) => {
    this.clearMarkerLongdomapLocation()

    if (type !== 'longdomapLocation') {
      map.zoom(20)
      map.location({ lon: value.lng, lat: value.lat })
    } else {
      let markerLongdoMapLocation = new window.longdo.Marker(
        { lon: value.lng, lat: value.lat },
        {
          icon: {
            html: renderToString(
              <PlaceMarkerLongdoMap
                title={value.name}
                key={value.id}
                lat={value.lat}
                lng={value.lon}
                transform="translate(-10%, 20%)"
                leftPosition="83"
              />,
            ),
            offset: { x: 12, y: 45 },
          },
          draggable: false,
        },
      )
      this.setState({
        markerLongdoMapLocation,
      })
      map.Overlays.add(markerLongdoMapLocation)
      map.zoom(20)
      map.location({ lon: value.lng, lat: value.lat })
    }
  }

  handleZoomIn = () => {
    map.zoom(true, true)
  }

  handleZoomOut = () => {
    map.zoom(false, true)
  }

  handleShowTrafficLayer = () => {
    if (this.state.showTrafficLayer) {
      map.Layers.remove(longdo.Layers.TRAFFIC)
      this.setState({
        showTrafficLayer: false,
      })
    } else {
      map.Layers.add(longdo.Layers.TRAFFIC)
      this.setState({
        showTrafficLayer: true,
      })
    }
  }

  handleCancel = () => {
    this.setState({
      visible: false,
      isMenuMapToolsCLick: '',
    })
  }

  confirmCreatePolygon = () => {
    let index = this.state.tempMarker.findIndex(
      x => x.title == this.state.getIdPolygon,
    )
    let filterPolygon = this.state.keepMarker.filter(
      item => item.id == this.state.getIdPolygon,
    )
    let value = this.state.apiData.filter(
      item => item.id == this.state.getIdPolygon,
    )
    let dataForm = [
      {
        geo_fence: this.state.geoFene.toString(),
        id: this.state.getIdPolygon,
        lat: value[0].lat,
        lng: value[0].lng,
        name: 'รถโม่เล็ก',
      },
    ]
    if (index > -1) {
      map.Overlays.remove(this.state.tempMarker[index])
      map.Overlays.remove(filterPolygon[0].overlay)
    }
    this.displayMarker(dataForm)
    this.setState(
      {
        geoFene: [],
        editable: false,
      },
      () => {
        message.success(`save success`)
      },
    )
  }

  handleSelectTool = type => {
    this.setState({ selectTools: type })
  }

  // Draw Polygon
  handleDrawPolyline = text => {
    let bound = map.bound()
    map.Overlays.clear()

    this.setState({
      selectTools: text,
      editValue: {
        route_name: '',
        remark: '',
      },
      loadDataThisArea: false,
      disableLoadDataThisArea: true,
      hideDraw: true,
      showNeighborhoodInformation: false,
      initialBoundBox: [
        { lat: bound.maxLat, lng: bound.maxLon },
        { lat: bound.maxLat, lng: bound.minLon },
        { lat: bound.minLat, lng: bound.minLon },
        { lat: bound.minLat, lng: bound.maxLon },
      ],
      isMenuMapToolsCLick: 'findArea',
      showClear: true,
      showSearch: false,
      hideToggleWhenDraw: true,
      getNote: '',
    })

    let self = this
    let array_latlng = []
    let geoFene = []
    let polyline = null

    map.Event.bind('click', function(overlay) {
      if (self.state.geoFene.length == 0) {
        array_latlng = []
        geoFene = []
        polyline = null
      }

      if (self.state.circle != null) {
        map.Overlays.remove(self.state.circle)
      }

      if (self.state.marker != null) {
        map.Overlays.remove(self.state.marker)
        self.setState({ marker: null })
      }

      if (self.state.markerWhenDrawing != null) {
        map.Overlays.remove(self.state.markerWhenDrawing)
        self.setState({ markerWhenDrawing: null })
      }

      if (self.state.isMenuMapToolsCLick == 'findArea') {
        self.handleClearDrawPolygon()
        let point = map.location(longdo.LocationMode.Pointer)
        let lat = parseFloat(point.lat.toFixed(6))
        let lon = parseFloat(point.lon.toFixed(6))

        let currentMakerWhenDrawing = new window.longdo.Marker({
          lon,
          lat,
        })

        map.Overlays.add(currentMakerWhenDrawing)

        array_latlng.push({ lon, lat })
        geoFene.push(lat, lon)

        self.setState(
          {
            previousPolyline: array_latlng,
            geoFene: geoFene,
            markerWhenDrawing: currentMakerWhenDrawing,
          },
          randerPolygon,
        )
      }
    })

    let lineColor = this.getLineColor(text)

    function randerPolygon() {
      if (array_latlng.length >= 2) {
        polyline = new longdo.Polyline(array_latlng, {
          lineWidth: 4,
          lineColor: lineColor,
        })
        map.Overlays.add(polyline)
        self.setState({ polyline: polyline })
      }
    }

    map.Event.bind('overlayDrop', function(overlay) {
      if (self.state.isMenuMapToolsCLick == 'findArea') {
        self.handleClearDrawPolygon()
        self.state.geoFene = []
        let arrPolyLine = []

        if (polyline != null) {
          polyline.location().map(val => {
            arrPolyLine.push(val.lat, val.lon)
          })

          polyline = new longdo.Polyline(polyline.location(), {
            editable: true,
            lineWidth: 4,
            lineColor: lineColor,
          })
        }

        map.Overlays.add(polyline)
        self.setState({ polyline: polyline, geoFene: arrPolyLine })
      }
    })
  }
  // End Drawing Area

  handleMapTypeSatellite = e => {
    map.Layers.setBase(longdo.Layers.GOOGLE_HYBRID)
  }

  handleMapTypeTerrain = e => {
    map.Layers.setBase(longdo.Layers.GOOGLE_ROADMAP)
  }

  openModalConfirmPolygon = () => {
    this.setState({
      showComfirmSavePolygon: true,
    })
  }

  onCloseModalComfirmpolygon = () => {
    this.setState({
      showComfirmSavePolygon: false,
    })
  }

  handlePinGoogleStreetview = () => {
    this.setState({
      selectTools: 'pinGgStreetview',
      hideDraw: true,
    })

    map.Event.bind('click', overlay => {
      if (this.state.ggStreetviewMarker !== null) {
        map.Overlays.remove(this.state.ggStreetviewMarker)
      }

      if (this.state.selectTools === 'pinGgStreetview') {
        let currentMaker = new window.longdo.Marker({
          lon: map.location(longdo.LocationMode.Pointer).lon,
          lat: map.location(longdo.LocationMode.Pointer).lat,
        })
        map.Overlays.add(currentMaker)

        this.setState({
          ggStreetviewMarker: currentMaker,
        })
      }
    })
  }

  handleCancelStreetview = () => {
    if (this.state.ggStreetviewMarker !== null) {
      map.Overlays.remove(this.state.ggStreetviewMarker)
    }

    this.setState({
      ggStreetviewMarker: null,
      selectTools: '',
      hideDraw: false,
    })
  }

  handlePinDoesNotExistInSystem = async location => {
    this.clearMarkerLongdomapLocation()
    await this.clearOverlayOnMapWhenSearchStartEnd()
    this.setState(
      {
        selectTools: 'pinDoesNotExistInSystem',
        showSearch: true,
        hideToggleWhenDraw: true,
        loadDataThisArea: false,
        disableLoadDataThisArea: true,
        hideDraw: true,
        showNeighborhoodInformation: false,
        showSearch: false,
      },
      () => {
        let self = this
        let my_location = new window.longdo.Marker(
          { lon: location.lon, lat: location.lat },
          {
            icon: {
              html: renderToString(
                <IconMyLocation
                  image="/img/Component 14 – 49.png"
                  title={i18n[this.props.language].y.you}
                />,
              ),
              offset: { x: 12, y: 45 },
            },
            draggable: true,
          },
        )
        map.Overlays.add(my_location)
        this.setState({
          my_location: my_location,
        })

        map.Event.bind('overlayDrop', function(overlay) {
          if (self.state.selectTools == 'pinDoesNotExistInSystem') {
            self.setState({
              btnCarThisArea: true,
              overlayDropLat: overlay.location().lat,
              overlayDropLng: overlay.location().lon,
            })
          }
        })
      },
    )
  }

  handlePrevious = () => {
    let previousGeofene = this.state.previousPolyline

    if (previousGeofene.length != 0) {
      previousGeofene.pop()
      let arr = []
      previousGeofene.forEach(element => {
        arr.push(element.lat)
        arr.push(element.lon)
      })

      this.setState(
        {
          previousPolyline: previousGeofene,
          geoFene: arr,
        },
        this.displayPreviousPolygon,
      )
    }
  }

  handleGetLocationFromSearch = value => {
    this.setState(
      {
        overlayDropLat: value.lat,
        overlayDropLng: value.lng,
        startPointLocationName: value.name,
      },
      () => {
        this.handleFindCarThisArea()
      },
    )
  }

  handleFindCarThisArea = () => {
    this.setState(
      {
        btnCarThisArea: false,
        loading: true,
      },
      () => {
        axios({
          method: 'post',
          url: `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/small-truck-route/nearbylocations`, // API URL
          headers: { Authorization: `Bearer ${this.props.auth.accessToken}` },
          data: {
            company_id: this.props.auth.profile.company_id,
            lat: this.state.overlayDropLat,
            lng: this.state.overlayDropLng,
            location_visibility: this.props.auth.profile.location_visibility,
          },
        }).then(res => {
          if (res.data.data.length > 0) {
            res.data.data.map((item, index) => {
              longdoAxios({
                method: 'get',
                url: `${LongdoEndpoint}/map/mmroute/geojson/route?flon=${this.state.overlayDropLng}&flat=${this.state.overlayDropLat}&tlon=${item.lng}1&tlat=${item.lat}&mode=d&type=17&locale=th&key=${this.props.auth.profile.longdo_map_key}`,
              })
                .then(res2 => {
                  res.data.data[index].distance = res2.data.data.tdistance
                })
                .catch(err => {
                  console.log(err)
                })
            })
            let sortingArray = res.data.data.sort(function compare(a, b) {
              if (a.distance < b.distance) {
                return -1
              }
              if (a.distance > b.distance) {
                return 1
              }
              return 0
            })
            this.setState(
              {
                nearByLocationList: sortingArray,
                loading: false,
              },
              () => {
                if (this.state.nearByLocationList.length > 0) {
                  this.handleShowNearestModal()
                } else {
                  message.error(this.context.l.locationIsEmpty)
                }
              },
            )
          } else {
            message.error(this.context.l.locationIsWrong)
          }
        })
      },
    )
  }

  onCloseSearchStartEndLocation = () => {
    if (this.state.routePolyline != null) {
      map.Overlays.remove(this.state.routePolyline)
      this.setState({
        routePolyline: null,
      })
    }
    if (this.state.my_location != null) {
      map.Overlays.remove(this.state.my_location)
      this.setState({
        my_location: null,
      })
    }
    if (this.state.end_marker != null) {
      map.Overlays.remove(this.state.end_marker)
      this.setState({
        end_marker: null,
      })
    }
    if (this.state.start_marker != null) {
      map.Overlays.remove(this.state.start_marker)
      this.setState({
        start_marker: null,
      })
    }
    this.setState({
      hideToggleWhenDraw: false,
      suggest_place: '',
      showNeighborhoodInformation: false,
      showSearchStartEndLocation: false,
      selectTools: '',
      hideDraw: false,
      showSearch: true,
    })

    let result = map.zoom()
    if (result >= 15) {
      this.loadData()
    } else {
      this.initialLoadDataToDefaultLocation()
    }
  }

  initialLoadDataToDefaultLocation = () => {
    map.zoom(16)
    map.location({ lon: 100.49149, lat: 13.75005 }, true)
    this.setState(
      {
        suggest_place: '',
        showNeighborhoodInformation: false,
        initialBoundBox: [
          {
            lat: 13.756261348904085,
            lng: 100.5286654829979,
          },
          {
            lat: 13.756261348904085,
            lng: 100.46806901693344,
          },
          {
            lat: 13.73445941145562,
            lng: 100.46806901693344,
          },
          {
            lat: 13.73445941145562,
            lng: 100.5286654829979,
          },
        ],
      },
      () => {
        this.loadData()
      },
    )
  }

  handleShowSearchStartEndLocation = () => {
    this.setState({
      showSearchStartEndLocation: true,
    })
  }

  handleMarkerPopup = () => {
    let popupMarker = new window.longdo.Popup(
      { lon: 100.4953296482563, lat: 13.756622178904763 },
      {
        html: renderToString(
          <PopupMarkerSmartDispatching
            style={{
              zIndex: 999,
              textAlign: 'center',
              alignItems: 'center',
              justifyContent: 'center',
              transform: 'translate(-50%, -180%)',
              position: 'absolute',
              marginLeft: '15px',
            }}
            image="/img/Direct.png"
            title="หน่วยงานสาทร 11"
          />,
        ),
        offset: { x: 12, y: 45 },
      },
    )
    map.Overlays.add(popupMarker)
  }

  handleZoomFocusIncrease = e => {
    map.zoom(true, true)
  }

  handleZoomFocusDecrease = e => {
    map.zoom(false, true)
  }

  handleSwitchLocation = () => {
    this.setState(
      prevState => {
        return {
          switchDestinationMode: !prevState.switchDestinationMode,
        }
      },
      () => {
        this.drawRouteNearBylocation({
          locationName: this.state.endPointLocationName,
          locationCode: this.state.endPointLocationCode,
        })
      },
    )
  }

  getLineColor = text => {
    let lineColor = ''
    let value = text.toString()
    switch (value) {
      case '1':
        lineColor = '#FFBA00'
        break
      case '2':
        lineColor = '#F53C56'
        break
      case '3':
        lineColor = '#FD3DB5'
        break
      case '7':
        lineColor = '#DA70D6'
        break
      default:
        break
    }
    return lineColor
  }

  genFilterBtnComponent = (isShow, text, onClick, isGpsMarker = false) => {
    let notAllow = this.state.disableLoadDataThisArea
    let btn = (
      <Button
        type={isShow ? 'primary' : ''}
        shape="round"
        style={{
          marginRight: '10px',
          marginBottom: '13px',
          color: isShow ? 'white' : '#172B4D',
          cursor: notAllow && 'not-allowed',
        }}
        onClick={!notAllow && onClick}
      >
        {text}
      </Button>
    )

    if (notAllow) {
      return (
        <Popover
          content={
            <LangContext.Consumer>
              {i18n => i18n.p.pleaseZoomInToSearch}
            </LangContext.Consumer>
          }
        >
          {btn}
        </Popover>
      )
    }
    return btn
  }

  circleToPolygon = (center, radius, sides) => {
    const vertices = []
    for (let i = 0; i < sides; i++) {
      const angle = (2 * Math.PI * i) / sides
      const x = center.x + radius * Math.cos(angle)
      const y = center.y + radius * Math.sin(angle)
      vertices.push({ lat: x, lon: y })
    }
    return vertices
  }

  handleDrawDeleteGpsRoutePolygon = () => {
    let polygonCoords = []
    let temp = []

    map.Event.bind('click', overlay => {
      if (this.state.polyGonGpsRouteLayer.length === 0) {
        polygonCoords = []
        temp = []
      }

      if (this.state.isMenuMapToolsCLick == 'drawRemoveGps') {
        map.Overlays.remove(this.state.polyGonGpsRouteLayer)

        let lon = map.location(longdo.LocationMode.Pointer).lon
        let lat = map.location(longdo.LocationMode.Pointer).lat

        polygonCoords.push({
          lat: parseFloat(lat.toFixed(6)),
          lon: parseFloat(lon.toFixed(6)),
        })

        let polygonLayer = []
        temp = [...polygonCoords]
        if (polygonCoords.length <= 2) {
          polygonLayer = new window.longdo.Polyline(temp, {
            editable: true,
            lineWidth: 2,
            lineColor: 'rgba(0, 128, 255, 0.6)',
          })
          map.Overlays.add(polygonLayer)
        } else {
          polygonLayer = new window.longdo.Polygon(temp, {
            lineWidth: 2,
            lineColor: '#A17DC0',
            fillColor: 'rgba(0, 128, 255, 0.6)',
            editable: true,
          })

          map.Overlays.add(polygonLayer)
        }

        this.setState({
          polyGonGpsRouteLayer: polygonLayer,
          polyGonGpsRoute: polygonCoords,
        })
      }
    })

    map.Event.bind('overlayDrop', overlay => {
      if (this.state.isMenuMapToolsCLick == 'drawRemoveGps') {
        let all = []
        let polygonLayer = this.state.polyGonGpsRouteLayer
        polygonLayer.location().map(val => {
          all.push({ lat: val.lat, lon: val.lon })
        })

        map.Overlays.remove(polygonLayer)
        map.Overlays.add(polygonLayer)

        this.setState({
          polyGonGpsRouteLayer: polygonLayer,
          polyGonGpsRoute: all,
        })
      }
    })
  }

  handleCancelDrawGpsRoutePolygon = () => {
    map.Overlays.remove(this.state.polyGonGpsRouteLayer)
    this.setState({
      polyGonGpsRouteLayer: [],
      polyGonGpsRoute: [],
      hideDraw: false,
      isMenuMapToolsCLick: '',
    })
  }

  handleDeleteGpsRoute = () => {
    let remove = []
    let polygon = []

    this.state.polyGonGpsRouteLayer.location().map(val => {
      polygon.push([val.lon, val.lat])
    })

    let extendedPolygon = turf.buffer(turf.polygon([polygon]), 5, {
      units: 'meters',
    })

    let temp = []
    extendedPolygon.geometry.coordinates[0].map(x => {
      temp.push({
        lon: parseFloat(x[0].toFixed(6)),
        lat: parseFloat(x[1].toFixed(6)),
      })
    })

    let polygonLayer = new window.longdo.Polygon(temp, {
      lineWidth: 2,
      lineColor: '#A17DC0',
      fillColor: 'rgba(0, 128, 255, 0.6)',
      editable: true,
    })

    this.state.objGpsRouteMarker.map(x => {
      if (polygonLayer.contains({ lat: x.lat, lon: x.lng })) {
        remove = [...remove, x['_id']]
      }
    })

    if (remove.length == 0) {
      message.info('ไม่พบจุดที่ต้องการลบ')
      this.handleCancelDrawGpsRoutePolygon()
      return
    }

    this.setState({ loading: true })

    axios
      .post(
        `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/small-truck-route/delete-gps`,
        { id: remove },
        { headers: { Authorization: `Bearer ${this.props.auth.accessToken}` } },
      )
      .then(res => {
        message.success('ลบข้อมูลสำเร็จ')
        this.loadData(() => {
          this.setState({
            isMenuMapToolsCLick: 'drawRemoveGps',
            hideDraw: true,
          })
        })
      })
      .catch(err => {
        message.error(getErrorMsg(err))
        this.setState({ loading: false })
      })
  }

  export = () => {
    axios
      .post(
        `${process.env.REACT_APP_API_REPORT_GOLANG}/reports/go/small-truck-route`,
      )
      .then(res => (window.location = res.data))
  }

  checkIsInPolygon = (vs, lat, lng) => {
    let inside = false
    var x = lat,
      y = lng

    for (var i = 0, j = vs.length - 1; i < vs.length; j = i++) {
      var xi = vs[i].lat,
        yi = vs[i].lon
      var xj = vs[j].lat,
        yj = vs[j].lon

      var intersect =
        yi > y != yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi
      if (intersect) inside = !inside
    }
    return inside
  }

  render() {
    const { loading } = this.props.SmartDispatching
    const mapTools = (
      <Menu
        style={{
          width: this.props.language == 'th' ? `260px` : `270px`,
          right: 0,
          borderRadius: 10,
        }}
      >
        <Menu.Item
          key="1"
          onClick={() => {
            this.handleDrawPolyline('1')
          }}
          disabled={this.state.hideDraw}
          style={{ marginBottom: '5px' }}
        >
          <Icon type="highlight" style={{ color: '#FFBA00' }} />
          <LangContext.Consumer>
            {i18n => i18n.d.drawSmallTruckRoute}
          </LangContext.Consumer>
        </Menu.Item>
        <Menu.Item
          key="2"
          onClick={() => {
            this.handleDrawPolyline('2')
          }}
          disabled={this.state.hideDraw}
          style={{ marginBottom: '5px' }}
        >
          <Icon type="highlight" style={{ color: '#F53C56' }} />
          <LangContext.Consumer>
            {i18n => i18n.d.drawSmallTruckRouteDoNotEnter}
          </LangContext.Consumer>
        </Menu.Item>
        <Menu.Item
          key="3"
          onClick={() => {
            this.handleDrawPolyline('3')
          }}
          disabled={this.state.hideDraw}
        >
          <Icon type="highlight" style={{ color: '#FD3DB5' }} />
          <LangContext.Consumer>
            {i18n => i18n.d.drawBigTruckRoute}
          </LangContext.Consumer>
        </Menu.Item>
        {/* ทางลาดชัน */}
        <Menu.Item
          key="7"
          onClick={() => {
            this.handleDrawPolyline('7')
          }}
          disabled={this.state.hideDraw}
        >
          <Icon type="highlight" style={{ color: '#DA70D6' }} />
          <LangContext.Consumer>
            {i18n => i18n.s.slopeDrawer}
          </LangContext.Consumer>
        </Menu.Item>
        <Menu.Item
          key="4"
          onClick={() => {
            this.handlePinDoesNotExistInSystem(map.location())
          }}
          disabled={this.state.hideDraw}
        >
          <Icon type="pushpin" />
          <LangContext.Consumer>
            {i18n => i18n.p.pinDoesNotExistInSystem}
          </LangContext.Consumer>
        </Menu.Item>
        <Menu.Item
          key="5"
          onClick={() => {
            this.setState(
              {
                isMenuMapToolsCLick: 'drawRemoveGps',
                hideDraw: true,
              },
              this.handleDrawDeleteGpsRoutePolygon,
            )
          }}
          disabled={this.state.hideDraw || !this.state.showGpsRouteMarker}
        >
          <Icon type="highlight" style={{ color: '#0080ff' }} />
          <LangContext.Consumer>
            {i18n => i18n.d.deletedPolygon}
          </LangContext.Consumer>
        </Menu.Item>
        <Menu.Item
          key="6"
          onClick={this.handlePinGoogleStreetview}
          disabled={this.state.hideDraw}
        >
          <Icon type="pushpin" style={{ color: '#50C878' }} />
          <LangContext.Consumer>
            {i18n => i18n.p.pinDownGG}
          </LangContext.Consumer>
        </Menu.Item>
      </Menu>
    )

    const mapType = (
      <Menu style={{ borderRadius: '10px' }}>
        <Menu.Item
          key="1"
          onClick={this.handleMapTypeSatellite}
          style={{ marginBottom: '5px' }}
        >
          <LangContext.Consumer>
            {i18n => i18n.s.satellite}
          </LangContext.Consumer>
        </Menu.Item>
        <Menu.Item key="2" onClick={this.handleMapTypeTerrain}>
          <LangContext.Consumer>{i18n => i18n.m.map}</LangContext.Consumer>
        </Menu.Item>
      </Menu>
    )
    return (
      <AuthorizeComponent {...this.props} matching_name="smartDispatching">
        <Spin spinning={loading || this.state.loading}>
          <SmartDispatchLayout>
            <Row gutter={24}>
              <Col
                span={24}
                style={{ paddingLeft: '0px', paddingRight: '0px' }}
              >
                {/* กลุ่มปุ่มรถโม่, กล่องค้นหาสถานที่, เครื่องมือ, มุมมองแผนที่ */}
                <div
                  style={{
                    position: 'absolute',
                    margin: '5px',
                    zIndex: '13',
                    justifyContent: 'space-between',
                    display: 'flex',
                    width: '100%',
                  }}
                >
                  <div style={{ width: '40%' }}>
                    {this.genFilterBtnComponent(
                      this.state.showRoute,
                      <LangContext.Consumer>
                        {i18n => i18n.s.smallTruckRoute}
                      </LangContext.Consumer>,
                      this.handleShowRoute,
                    )}
                    {this.genFilterBtnComponent(
                      this.state.showGpsRouteMarker,
                      <LangContext.Consumer>
                        {i18n => i18n.s.smallTruckRouteFromGps}
                      </LangContext.Consumer>,
                      this.handleshowGpsRouteMarker,
                      true,
                    )}
                    {this.genFilterBtnComponent(
                      this.state.showRouteDoNotEnter,
                      <LangContext.Consumer>
                        {i18n => i18n.s.smallTruckRouteDoNotEnter}
                      </LangContext.Consumer>,
                      this.handleShowRouteDoNotEnter,
                    )}
                    {this.genFilterBtnComponent(
                      this.state.showRouteBigTruck,
                      <LangContext.Consumer>
                        {i18n => i18n.b.bigTruckRoute}
                      </LangContext.Consumer>,
                      this.handleShowRouteBigTruck,
                    )}
                    {this.genFilterBtnComponent(
                      this.state.showPlantCpac,
                      <LangContext.Consumer>
                        {i18n => i18n.s.showCpacPlant}
                      </LangContext.Consumer>,
                      this.handleShowPlantCpac,
                    )}
                    {this.genFilterBtnComponent(
                      this.state.showSiteSmallTruck,
                      <LangContext.Consumer>
                        {i18n => i18n.s.siteSmallTruck}
                      </LangContext.Consumer>,
                      this.handleShowSiteSmallTruck,
                    )}
                    {this.genFilterBtnComponent(
                      this.state.showSiteLargeTruck,
                      <LangContext.Consumer>
                        {i18n => i18n.s.siteLargeTruck}
                      </LangContext.Consumer>,
                      this.handleShowSiteLargeTruck,
                    )}
                    {this.genFilterBtnComponent(
                      this.state.showSlope,
                      <LangContext.Consumer>
                        {i18n => i18n.s.slope}
                      </LangContext.Consumer>,
                      this.handleShowSlopeRoute,
                    )}
                  </div>

                  <div
                    style={{
                      width: '60%',
                      display: 'flex',
                      justifyContent: 'end',
                      marginRight: '10px',
                    }}
                  >
                    <div style={{ width: '40%' }}>
                      {!this.state.showSearchStartEndLocation && (
                        <LangContext.Consumer>
                          {i18n => (
                            <Input
                              placeholder={i18n.f.findTheDesiredLocation}
                              suffix={
                                <>
                                  <Icon
                                    type="search"
                                    style={{
                                      color: 'red',
                                      fontSize: '1.2rem',
                                    }}
                                    onClick={() => {
                                      if (this.state.suggest_place === '') {
                                        return
                                      }
                                      this.setState({
                                        loadDataThisArea: false,
                                        initialBoundBox: [],
                                      })
                                      this.loadData()
                                    }}
                                  />
                                  {this.state.showNeighborhoodInformation && (
                                    <>
                                      <Divider type="vertical" />
                                      <Icon
                                        type="close"
                                        style={{
                                          color: 'red',
                                          fontSize: '1.2rem',
                                        }}
                                        onClick={() => {
                                          let result = map.zoom()
                                          if (result >= 15) {
                                            this.setState(
                                              {
                                                suggest_place: '',
                                                showNeighborhoodInformation: false,
                                              },
                                              () => {
                                                this.clearMarkerLongdomapLocation()
                                                this.loadData()
                                              },
                                            )
                                          } else {
                                            this.clearMarkerLongdomapLocation()
                                            this.initialLoadDataToDefaultLocation()
                                          }
                                        }}
                                      />
                                    </>
                                  )}
                                </>
                              }
                              onChange={e => {
                                this.setState({
                                  suggest_place: e.target.value,
                                })
                              }}
                              onPressEnter={() => {
                                this.setState({
                                  loadDataThisArea: false,
                                  initialBoundBox: [],
                                })
                                this.loadData()
                              }}
                              size="large"
                              value={this.state.suggest_place}
                              className="button-search-smart-dispatching"
                            />
                          )}
                        </LangContext.Consumer>
                      )}
                    </div>
                    <div style={{ width: '40%', textAlign: 'end' }}>
                      <ButtonGroup
                        style={{
                          marginRight: '4px',
                        }}
                      >
                        <Dropdown
                          className="edge-element"
                          overlay={mapTools}
                          disabled={
                            this.state.isMenuMapToolsCLick == 'updateRoute'
                              ? true
                              : false
                          }
                        >
                          <Button
                            size="default"
                            style={{
                              color:
                                this.state.isMenuMapToolsCLick == 'updateRoute'
                                  ? 'gray'
                                  : '#172B4D',
                              height: '40px',
                              width: '130px',
                              borderRadius: '10px 0px 0px 10px',
                              border: 'none',
                              borderRight: '1px solid #ebebeb',
                            }}
                          >
                            <LangContext.Consumer>
                              {i18n => i18n.t.tools}
                            </LangContext.Consumer>{' '}
                            <Icon type="down" />
                          </Button>
                        </Dropdown>
                        <Dropdown className="edge-element" overlay={mapType}>
                          <Button
                            size="default"
                            style={{
                              color: '#172B4D',
                              width: '130px',
                              height: '40px',
                              borderRadius: '0px 10px 10px 0px',
                              border: 'none',
                              borderLeft: '1px solid #ebebeb',
                            }}
                          >
                            <LangContext.Consumer>
                              {i18n => i18n.m.mapview}
                            </LangContext.Consumer>{' '}
                            <Icon type="down" />
                          </Button>
                        </Dropdown>
                      </ButtonGroup>

                      {checkPermissions(
                        this.props.auth.profile.permissions,
                        'smartDispatching',
                        'can_special_1',
                      ) && (
                        <Tooltip
                          title={this.context.e.exportRoute}
                          placement="bottomRight"
                        >
                          <Button
                            style={{
                              marginLeft: '4px',
                              borderRadius: '32px',
                            }}
                            size="large"
                            icon="upload"
                            onClick={this.export}
                          />
                        </Tooltip>
                      )}
                    </div>
                  </div>
                </div>

                {/* กล่องแสดงสถานที่จาก longdo เวลากดค้นทาง, ส่วนค้นหาต้นทางปลายทาง */}
                <div
                  style={{
                    position: 'absolute',
                    marginTop: '4px',
                    top: '61px',
                    left: '5px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '100%',
                  }}
                >
                  <div style={{ width: '50%', marginTop: '35px' }}>
                    {this.state.showSearchStartEndLocation && (
                      <SearchStartEndLocation
                        onClose={this.onCloseSearchStartEndLocation}
                        startLocation={this.state.startPointLocationName}
                        endLocation={this.state.endPointLocationName}
                        handleShowNearestModal={this.handleShowNearestModal}
                        disabled={true}
                        handleSwitchLocation={this.handleSwitchLocation}
                        switchDestinationMode={this.state.switchDestinationMode}
                      />
                    )}

                    {this.state.showNeighborhoodInformation && (
                      <NeighborhoodInformation
                        handleGetIdForEditOrDelete={
                          this.handleGetIdForEditOrDelete
                        }
                        handleMarkerPopup={this.handleMarkerPopup}
                        handleShowNearestModal={this.handleShowNearestModal}
                        allDataFromSearch={this.state.allDataFromSearch}
                        openNotification={this.openNotification}
                        handleGotoLocation={this.handleGotoLocation}
                        handleGetLocationFromSearch={
                          this.handleGetLocationFromSearch
                        }
                        longdoMapLocationList={this.state.longdoMapLocationList}
                      />
                    )}
                  </div>

                  <div
                    style={{
                      width: '50%',
                      display: 'flex',
                      marginRight: '15px',
                      flexDirection: 'column',
                    }}
                  >
                    {![
                      '',
                      'pinDoesNotExistInSystem',
                      'directionRoute',
                      'pinGgStreetview',
                    ].includes(this.state.selectTools) &&
                      this.state.isMenuMapToolsCLick !== 'updateRoute' && (
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'end',
                            marginBottom: '10px',
                            zIndex: '13',
                          }}
                        >
                          <Button
                            size="default"
                            style={{
                              color:
                                this.state.geoFene.length >= 2
                                  ? '#172B4D'
                                  : 'gray',
                              height: '40px',
                            }}
                            onClick={this.handlePrevious}
                            disabled={
                              this.state.geoFene.length >= 2 ? false : true
                            }
                          >
                            <Icon type="undo" />{' '}
                            <LangContext.Consumer>
                              {i18n => i18n.p.previous}
                            </LangContext.Consumer>
                          </Button>
                        </div>
                      )}

                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'end',
                        zIndex: '13',
                      }}
                    >
                      {this.state.isMenuMapToolsCLick === 'findArea' && (
                        <>
                          <Button
                            style={{ marginRight: '5px', width: '115px' }}
                            onClick={this.openModalConfirmPolygon}
                            type="primary"
                            disabled={
                              this.state.geoFene.length >= 4 ? false : true
                            }
                          >
                            <LangContext.Consumer>
                              {i18n => i18n.s.save}
                            </LangContext.Consumer>
                          </Button>
                          <Button
                            style={{ width: '115px' }}
                            onClick={() => {
                              this.handleCancelDrawPolygon()
                            }}
                          >
                            <LangContext.Consumer>
                              {i18n => i18n.c.cancel}
                            </LangContext.Consumer>
                          </Button>
                        </>
                      )}

                      {this.state.isMenuMapToolsCLick == 'updateRoute' && (
                        <>
                          <Button
                            style={{ marginRight: '5px', width: '115px' }}
                            onClick={() => {
                              this.openModalConfirmPolygon()
                            }}
                            type="primary"
                            disabled={
                              this.state.newGeoFene.length >= 4 ? false : true
                            }
                          >
                            <LangContext.Consumer>
                              {i18n => i18n.s.save}
                            </LangContext.Consumer>
                          </Button>
                          <Button
                            style={{ width: '115px' }}
                            onClick={this.handleCancelEditPolygon}
                          >
                            <LangContext.Consumer>
                              {i18n => i18n.c.cancel}
                            </LangContext.Consumer>
                          </Button>
                        </>
                      )}

                      {this.state.selectTools == 'pinDoesNotExistInSystem' &&
                        this.state.isMenuMapToolsCLick !== 'updateRoute' && (
                          <Button
                            style={{
                              minWidth: '259px',
                              borderRadius: '5px',
                              height: '40px',
                              border: 'transparent',
                              color: '#172b4d',
                            }}
                            onClick={() => {
                              map.Overlays.remove(this.state.my_location)
                              this.checkDisableButton()
                              let bound = map.bound()
                              this.setState({
                                loadDataThisArea: false,
                                selectTools: '',
                                hideToggleWhenDraw: false,
                                suggest_place: '',
                                showSearch: true,
                                showNeighborhoodInformation: false,
                                my_location: null,
                                hideDraw: false,
                                initialBoundBox: [
                                  { lat: bound.maxLat, lng: bound.maxLon },
                                  { lat: bound.maxLat, lng: bound.minLon },
                                  { lat: bound.minLat, lng: bound.minLon },
                                  { lat: bound.minLat, lng: bound.maxLon },
                                ],
                              })
                            }}
                          >
                            <LangContext.Consumer>
                              {i18n => i18n.c.cancel}
                            </LangContext.Consumer>
                          </Button>
                        )}

                      {this.state.selectTools == 'pinGgStreetview' && (
                        <>
                          <Button
                            style={{ marginRight: '5px' }}
                            onClick={() => {
                              if (this.state.ggStreetviewMarker !== null) {
                                window.open(
                                  `http://www.google.com/maps?layer=c&cbll=${
                                    this.state.ggStreetviewMarker.location().lat
                                  },${
                                    this.state.ggStreetviewMarker.location().lon
                                  }`,
                                  '_blank',
                                )
                              }
                            }}
                          >
                            Google Street View
                          </Button>
                          <Button
                            style={{ width: '115px' }}
                            onClick={this.handleCancelStreetview}
                          >
                            <LangContext.Consumer>
                              {i18n => i18n.c.cancel}
                            </LangContext.Consumer>
                          </Button>
                        </>
                      )}

                      {this.state.isMenuMapToolsCLick == 'drawRemoveGps' && (
                        <>
                          <Popconfirm
                            title={
                              <LangContext.Consumer>
                                {i18n => i18n.d.doYouWantToDeleteTheseItems}
                              </LangContext.Consumer>
                            }
                            disabled={
                              this.state.polyGonGpsRoute.length >= 3
                                ? false
                                : true
                            }
                            onConfirm={() => {
                              this.handleDeleteGpsRoute()
                            }}
                          >
                            <Button
                              style={{ marginRight: '5px', width: '115px' }}
                              type="primary"
                              disabled={
                                this.state.polyGonGpsRoute.length >= 3
                                  ? false
                                  : true
                              }
                            >
                              <LangContext.Consumer>
                                {i18n => i18n.d.delete}
                              </LangContext.Consumer>
                            </Button>
                          </Popconfirm>

                          <Button
                            style={{ width: '115px' }}
                            onClick={this.handleCancelDrawGpsRoutePolygon}
                          >
                            <LangContext.Consumer>
                              {i18n => i18n.c.cancel}
                            </LangContext.Consumer>
                          </Button>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                {/* ปุ่ม zoomin zoomout */}
                <div
                  className="edge-btn-group"
                  style={{
                    position: 'absolute',
                    top: 350,
                    right: '5px',
                    zIndex: '12',
                  }}
                >
                  <Tooltip
                    placement="left"
                    title={
                      <LangContext.Consumer>
                        {i18n => i18n.z.zoomIn}
                      </LangContext.Consumer>
                    }
                  >
                    <Button
                      type="primary"
                      onClick={this.handleZoomFocusIncrease}
                      style={{
                        borderRadius: '10px 10px 0px 0px',
                        border: 'none',
                        height: '40px',
                        borderBottom: '1px solid #ebebeb',
                      }}
                    >
                      <Icon type="plus" />
                    </Button>
                  </Tooltip>
                  <Tooltip
                    placement="left"
                    title={
                      <LangContext.Consumer>
                        {i18n => i18n.z.zoomOut}
                      </LangContext.Consumer>
                    }
                  >
                    <Button
                      type="primary"
                      onClick={this.handleZoomFocusDecrease}
                      style={{
                        borderRadius: '0px 0px 10px 10px',
                        border: 'none',
                        height: '40px',
                      }}
                    >
                      <Icon type="minus" />
                    </Button>
                  </Tooltip>
                </div>

                {/* ปุ่มค้นหารถข้างล่าง */}
                {this.state.btnCarThisArea && (
                  <div
                    style={{
                      position: 'absolute',
                      bottom: '15px',
                      zIndex: '12',
                      width: '100%',
                      textAlign: 'center',
                    }}
                  >
                    <Button
                      type="primary"
                      shape="round"
                      style={{
                        marginRight: '10px',
                        color: 'white',
                      }}
                      onClick={() => {
                        this.setState(
                          {
                            startPointLocationName:
                              i18n[this.props.language].y.yourLocation,
                          },
                          () => {
                            this.handleFindCarThisArea()
                          },
                        )
                      }}
                    >
                      <LangContext.Consumer>
                        {i18n => i18n.f.findThisArea}
                      </LangContext.Consumer>
                    </Button>
                  </div>
                )}

                {/* ปุ่มค้นหาข้างล่าง */}
                {this.state.loadDataThisArea && (
                  <div
                    style={{
                      position: 'absolute',
                      bottom: '15px',
                      zIndex: '12',
                      width: '100%',
                      textAlign: 'center',
                    }}
                  >
                    <Button
                      type="primary"
                      shape="round"
                      style={{
                        marginRight: '10px',
                        color: this.state.disableLoadDataThisArea
                          ? '#b1b1b1'
                          : 'white',
                        border: 'none',
                      }}
                      onClick={() => {
                        this.setState(
                          {
                            loadDataThisArea: false,
                            suggest_place: '',
                            showNeighborhoodInformation: false,
                          },
                          () => this.loadData(),
                        )
                      }}
                      disabled={this.state.disableLoadDataThisArea}
                    >
                      {this.state.disableLoadDataThisArea ? (
                        <LangContext.Consumer>
                          {i18n => i18n.p.pleaseZoomInToSearch}
                        </LangContext.Consumer>
                      ) : (
                        <LangContext.Consumer>
                          {i18n => i18n.f.findCarThisArea}
                        </LangContext.Consumer>
                      )}
                    </Button>
                  </div>
                )}

                <div id="map" className="smart__dipatching__map"></div>
              </Col>
            </Row>
          </SmartDispatchLayout>
        </Spin>
        <ModalConfirmPolygon
          showModal={this.state.showComfirmSavePolygon}
          onClose={this.onCloseModalComfirmpolygon}
          selectTools={this.state.selectTools}
          handleSelectTool={this.handleSelectTool}
          onChangeName={this.onChangeNameRoute}
          nameRoute={this.state.nameRoute}
          remark={this.state.getNote}
          handleRemark={this.onChangeRemark}
          handleSavePolygon={this.handleSavePolygon}
          handleUpdatePolygon={this.handleUpdatePolygon}
          isMenuMapToolsCLick={this.state.isMenuMapToolsCLick}
          editValue={this.state.editValue}
        />
        <ModalEditDeleteRoute
          showModal={this.state.showModalEditDeleteRoute}
          onClose={this.onCLoseModalEditDeleteRoute}
          objRoute={this.state.getNote}
          deletelocation={this.deletelocation}
          editlocation={this.editlocation}
        />
        <ListNearestModal
          showModal={this.state.showListNearestModal}
          onClose={this.onCloseNearestModal}
          chooseRoute={this.drawRouteNearBylocation}
          nearByLocationList={this.state.nearByLocationList}
        />
        <Notification
          showModal={this.state.showNotification}
          onClose={this.onCloseNotification}
          infoSearch={this.state.infoSearch}
        />
      </AuthorizeComponent>
    )
  }
}

export default connect(
  ({ SmartDispatching, auth, auth: { profile }, ui: { language } }) => ({
    auth,
    profile,
    SmartDispatching,
    language,
  }),
  {
    updateSmartDispatching: updateSmartDispatching.request,
    createSmartDispatching: createSmartDispatching.request,
    getNearByLocationSmartDispatching:
      getNearByLocationSmartDispatching.request,
  },
)(Index)
